import { t as xt } from "./module.esm-DopLWBnH.js";
import { t as dn } from "./queueBounce-BYbNS_fP.js";
import { t as lt } from "./morphNodes-DmouWQ1Y.js";
import { n as fn, r as hn, t as pn } from "./searchStore-AmAscPtC.js";
var vn = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, Ae = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, mn = (t) => t.data("addressSwitch", ({ addresses: e }) => ({
  addresses: e,
  slideTransition: Ae,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(n) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((i) => i.id === n), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), gn = (t) => t.data("announcement", (e) => {
  const { settings: n } = e;
  return {
    current: 0,
    init() {
      n.auto_scroll && e.count > 0 && this.autoScroll(), this.$watch("current", (i) => this.autoScroll(i));
    },
    change(i) {
      this.current = i;
    },
    autoScroll(i = 0) {
      i >= e.count ? i = 0 : i += 1, setTimeout(() => this.change(i), n.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), bn = (t) => {
  t.data("backInStock", (e, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: e,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const i = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", r = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const a = await fetch(i, r);
        if (!a.ok) throw new Error("Failed to subscribe");
        if (!(await a.json()).success) throw new Error("Failed to subscribe");
      } catch (a) {
        console.error(a);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, yn = (t) => {
  t.data("cardBadges", (e) => ({
    product: e,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(n) {
      const i = this.product.additional_data || {};
      for (const r of n.keys || []) {
        const a = i[r], o = Array.isArray(a) ? a.find((s) => String(s).trim() !== "") : a;
        if (o != null && String(o).trim() !== "") return String(o).trim();
      }
      return "";
    },
    badgeLabel(n) {
      if (n.kind === "tag") return (this.product.tags || []).map((r) => String(r).trim().toLowerCase()).includes(n.tag) ? n.label : null;
      if (n.kind === "sold_out") return this.product.available === !1 ? n.label : null;
      const i = this.badgeFieldValue(n);
      return i === "" || i === "false" || i === "0" ? null : n.kind === "metafield_text" ? i : n.label;
    },
    resolveBadge() {
      for (const n of this.badgeRules) {
        const i = this.badgeLabel(n);
        if (i) return {
          ...n,
          label: i
        };
      }
      return null;
    }
  }));
}, ot = (t, e) => e instanceof t ? e : null, wn = (t, e, n = 0) => Math.min(Math.max(t, n), e), Et = {}, xn = async (t) => {
  const e = t.toString();
  if (Et[e]) return Et[e];
  const n = await fetch(t);
  return n.ok ? (Et[e] = await n.text(), Et[e]) : null;
}, Sn = () => new Promise((t) => queueMicrotask(() => setTimeout(t, 0))), En = (t, e, n = 0) => (t - n) % (e - n) + n, Tn = (t) => t.data("cartDrawer", () => ({
  activeUpdates: 0,
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = t.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh, { signal: this.$abortSignal }), this.$store.cart.addEventListener("load", this.refresh, { signal: this.$abortSignal });
  },
  async refresh() {
    const e = new URL(window.location.href), n = dt();
    this.activeUpdates++, e.searchParams.set("sections", n.join(","));
    const i = await fetch(e);
    if (n.length && --this.activeUpdates == 0) {
      const r = await i.json();
      lt(Object.values(r).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async removeItem(e) {
    const n = { [e]: 0 }, i = dt();
    this.activeUpdates++;
    const r = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: n,
        sections: i.join(",")
      })
    });
    if (i.length && --this.activeUpdates == 0) {
      const a = await r.json();
      lt(Object.values(a.sections).join(""), []);
    }
  },
  async updateItem(e, n) {
    const i = { [e]: n }, r = dt();
    this.activeUpdates++;
    const a = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: i,
        sections: r.join(",")
      })
    });
    if (r.length && --this.activeUpdates == 0) {
      const o = await a.json();
      lt(Object.values(o.sections).join(""), []);
    }
  },
  async changeItem(e, n) {
    const i = dt();
    this.activeUpdates++;
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: e,
        properties: n,
        sections: i.join(",")
      })
    });
    if (i.length && --this.activeUpdates == 0) {
      const a = await r.json();
      lt(Object.values(a.sections).join(""), []);
    }
  },
  async changeSellingPlan(e, n, i = 1) {
    const r = {
      id: e,
      selling_plan: n,
      quantity: i
    }, a = dt();
    this.activeUpdates++;
    const o = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...r,
        sections: a.join(",")
      })
    });
    if (a.length && --this.activeUpdates == 0) {
      const s = await o.json();
      lt(Object.values(s.sections).join(""), []);
    }
  }
})), dt = () => {
  const t = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (e) => e?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(t));
}, kn = (t) => t.data("collectionFilters", (e) => ({
  ...e,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), In = (t) => t.data("collectionProductForm", (e) => ({
  storeKey: e.storeKey,
  products: [],
  selectedProductIdx: 0,
  selectedVariantId: null,
  loading: !1,
  get product() {
    return this.products[this.selectedProductIdx] || null;
  },
  get variantOptions() {
    return this.product ? this.product.variants.map((n) => ({
      id: n.id,
      label: n.title,
      price: n.price,
      compareAtPrice: n.compareAtPrice
    })) : [];
  },
  get productOptions() {
    return this.products.map((n, i) => ({
      idx: i,
      label: n.title,
      price: n.variants[0]?.price || ""
    })).sort((n, i) => parseInt(n.label) - parseInt(i.label));
  },
  get sellingPlanId() {
    return this.product?.sellingPlanGroups?.[0]?.sellingPlans?.[0]?.id ?? null;
  },
  get selectedVariant() {
    return !this.product || !this.selectedVariantId ? null : this.product.variants.find((n) => n.id === this.selectedVariantId) ?? null;
  },
  get canBuy() {
    return !!this.selectedVariantId;
  },
  onVariantChange() {
    this.syncStore();
  },
  syncStore() {
    const n = t.store(this.storeKey);
    n && (n.productId = this.product?.id ?? null, n.variantId = this.selectedVariantId, n.imageUrl = this.selectedVariant?.image || this.product?.featuredImage || "");
  },
  async addToCart() {
    if (!this.canBuy) return;
    this.loading = !0;
    const n = {
      id: this.selectedVariantId,
      quantity: 1
    };
    this.sellingPlanId && (n.selling_plan = this.sellingPlanId);
    try {
      (await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [n] })
      })).ok && this.$store.cart.open();
    } catch (i) {
      console.error("Add to cart failed:", i);
    } finally {
      this.loading = !1;
    }
  },
  init() {
    if (this.products = JSON.parse(document.getElementById(e.dataId).textContent), t.store(this.storeKey) || t.store(this.storeKey, {
      productId: null,
      variantId: null,
      imageUrl: null
    }), e.defaultProduct) {
      const n = this.products.findIndex((i) => i.title.toLowerCase().includes(e.defaultProduct.toLowerCase()));
      n !== -1 && (this.selectedProductIdx = n);
    }
    this.syncStore(), this.$watch("selectedProductIdx", (n, i) => {
      const r = this.products[i]?.variants.find((a) => a.id === this.selectedVariantId)?.title ?? null;
      if (this.selectedVariantId = null, r) {
        const a = this.products[n]?.variants.find((o) => o.title === r);
        a && (this.selectedVariantId = a.id);
      }
      this.syncStore();
    });
  }
})), Cn = (t) => t.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (e) => !e && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), Nn = (t) => {
  t.addRootSelector(() => `[${t.prefixed("dynamic-image")}]`), t.addInitSelector(() => `[${t.prefixed("dynamic-image-broadcaster")}]`), t.directive("dynamic-image", Re), t.directive("dynamic-image-broadcaster", On), t.directive("dynamic-image-image", _n);
}, $e = /* @__PURE__ */ new WeakMap(), Re = (t, e, { Alpine: n }) => {
  console.log("Setting up Dynamic Image Node");
  const i = $e.get(t);
  if (!i) return console.error("Dynamic Image Failed to Register: ", t, e.value);
  n.addScopeToNode(t, i);
};
Re.inline = (t, e, { Alpine: n, cleanup: i }) => {
  console.log("Setting Dynamic Image Handler");
  const r = n.reactive({ image: null });
  $e.set(t, r);
  const a = new AbortController();
  t.closest("section")?.addEventListener("dynamic-image-update", (o) => {
    console.log("Dynamic Image receiving Event"), r.image = o.detail;
  }, { signal: a.signal }), i(a.abort.bind(a));
};
var On = (t, { value: e, expression: n, modifiers: i }, { Alpine: r, cleanup: a }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), e === "intersect") {
    console.log("Dynamic Image Root:", n);
    const o = new IntersectionObserver((s) => {
      for (const l of s) l.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), Ln(t)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: n });
    i.includes("parent") && o.observe(t.parentElement), o.observe(t), a(o.disconnect.bind(o));
  }
}, Ln = (t) => {
  t.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(t.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, _n = (t, e, { Alpine: n, effect: i }) => {
  if (!(t instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const r = t.content;
  let a = null;
  const o = n.$data(t);
  console.log("Registering Dynamic Image Effect"), i(() => {
    if (console.log("running Dynamic Image Effect"), "image" in o && o.image) {
      const s = o.image, l = document.importNode(r, !0).firstElementChild;
      if (!(l instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (n.bind(l, {
        "x-rias"() {
          return s.url;
        },
        width: s.width,
        height: s.height,
        alt: s.alt
      }), (a ?? t).after(l), new Animation(new KeyframeEffect(l, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), a) {
        const c = new Animation(new KeyframeEffect(a, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        c.play(), c.addEventListener("finish", a.remove.bind(a));
      }
      a = l;
    }
  });
}, Fn = (t) => t == null ? [] : Array.isArray(t) ? t.map((e) => Number(e)) : typeof t == "number" && !Number.isNaN(t) ? [t] : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean).map((e) => Number(e)) : [], An = (t) => t ? Array.isArray(t) ? t.map(String) : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean) : [] : [], $n = (t) => t ? typeof t == "string" ? t : String(t) : "", Tt = (t) => {
  const e = t ?? {};
  let n = Number(e.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let i = Number(e.leadTime);
  return Number.isFinite(i) || (i = 0), {
    cutOffHour: n,
    leadTime: i,
    messageHtml: $n(e.messageHtml),
    isCustomMessage: !!e.isCustomMessage,
    restrictedDays: Fn(e.restrictedDays),
    restrictedDates: An(e.restrictedDates)
  };
}, re = (t) => t.dayOfWeek % 7, Rn = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], Dn = (t) => {
  let e = Math.max(0, Math.floor(t));
  const n = Math.floor(e / 86400);
  e %= 86400;
  const i = Math.floor(e / 3600);
  return e %= 3600, {
    days: n,
    hours: i,
    minutes: Math.floor(e / 60),
    seconds: e % 60
  };
}, Pn = (t) => {
  const e = t.dataset.esCfgId;
  if (!e) return Tt(void 0);
  const n = document.getElementById(e);
  if (!n?.textContent?.trim()) return Tt(void 0);
  try {
    const i = JSON.parse(n.textContent);
    return Tt(i);
  } catch {
    return Tt(void 0);
  }
}, Wt = "America/Chicago", Mn = (t) => {
  t.data("estimatedShipping", (e = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-ShPgAYTn.js"), Object.assign(this, Pn(this.$el), e), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const n = Temporal.Now.zonedDateTimeISO(Wt), i = this.nextCutoffDate(), r = i.epochNanoseconds - n.epochNanoseconds, a = r <= 0n ? 0 : Number(r / 1000000000n), { days: o, hours: s, minutes: l, seconds: c } = Dn(a), d = [];
      (d.length || o) && d.push(o === 1 ? `${o} day` : `${o} days`), (d.length || s) && d.push(s === 1 ? `${s} hour` : `${s} hours`), (d.length || l) && d.push(l === 1 ? `${l} minute` : `${l} minutes`), (d.length || c) && d.push(c === 1 ? `${c} second` : `${c} seconds`);
      const u = this.nextShippingDate(i), p = u.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : Rn[re(u)];
      this.message = String(this.messageHtml).replace("%countdown%", d.join(", ")).replace("%ship_day%", p);
    },
    nextCutoffDate() {
      const n = Temporal.Now.zonedDateTimeISO(Wt);
      let i = Temporal.Now.zonedDateTimeISO(Wt).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(i, n) === -1 && (i = i.add({ days: 1 })); this.isDateRestricted(i); ) i = i.add({ days: 1 });
      return i;
    },
    nextShippingDate(n) {
      let i = n, r = this.leadTime;
      for (; this.isDateRestricted(i) || r > 0; )
        i = i.add({ days: 1 }), this.isDateRestricted(i) || r--;
      return i;
    },
    isDateRestricted(n) {
      if (this.restrictedDays.includes(re(n))) return !0;
      const i = n.toPlainDate().toString(), r = i.slice(5);
      return this.restrictedDates.some((a) => a === i || a === r);
    }
  }));
}, jn = (t) => {
  t.data("filterController", (i) => {
    const r = [];
    return i || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await t.nextTick(), this.facetChange(!1), r.push(t.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: a }) {
        this.facetData = a ? JSON.parse(a) : this.facetChange();
        const o = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((c) => {
          c.checked = o.some(([d, u]) => d === c.name && u === c.value);
        });
        const s = o.find(([c]) => c === "sort_by")?.[1];
        if (!s) return;
        const l = document.querySelector('select[name="sort_by"]');
        l && (l.value = s);
      },
      destroy() {
        r.forEach(t.release);
      },
      _expanded: [!0],
      expanded(a) {
        return this._expanded[a];
      },
      expand(a) {
        this._expanded[a] = !this._expanded[a];
      },
      open: !1,
      fadeTransition: vn,
      slideTransition: Ae,
      facetData: [],
      facetChange(a = !0) {
        return this.facetData = Object.values(this.forms).flatMap((o) => Array.from(new FormData(o).entries())).filter(([o, s]) => !(o === "sort_by" && s === "manual" || o === "page" && (a || s === "1"))), this.facetData;
      },
      filterProducts() {
        n(this.facetData, i);
      },
      get isFiltered() {
        return this.facetData.some(([a]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(a));
      }
    };
  });
  let e = !0;
  const n = dn(async (i, r) => {
    const a = new URL(window.location.href);
    a.search = new URLSearchParams(i).toString();
    const o = await xn(a);
    if (!o) return;
    e || lt(o, r);
    const s = a.toString() === window.location.href;
    history[e || s ? "replaceState" : "pushState"](JSON.stringify(i), "", a.toString()), e = !1;
  });
}, Bn = (t) => {
  t.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, t.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), t.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((e) => e) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, Vn = (t) => t.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const e = this.$refs.menuDrawer;
    if (!e) return;
    const n = e.closest("section > :is(div.relative, div.absolute)");
    if (!n) return;
    const i = n.getBoundingClientRect(), r = i.y + i.height;
    this.size = `${r}px`;
  },
  adjustToLargestPart(e) {
    const n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT);
    let i = 0, r = e;
    do
      i = Math.max(i, r.scrollHeight);
    while (r = n.nextNode());
    this.size = `${i + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((e) => e.removeAttribute("open"));
  }
})), qn = (t) => t.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (e) => {
      !e && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(e = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, e && this.$store.modal.close();
  }
})), Hn = (t) => {
  t.addRootSelector(() => `[${t.prefixed("panel-stack")}]`), t.directive("panel-stack", Un);
}, zn = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), Un = (t, { expression: e }, { Alpine: n, effect: i, cleanup: r }) => {
  const a = n.reactive({ index: 0 }), o = new AbortController();
  r(o.abort.bind(o)), i(() => {
    const s = a.index;
    Kn(t).forEach((l, c) => {
      l.classList.toggle("panel-current", c === s), l.classList.toggle("panel-previous", c < s), l.classList.toggle("panel-next", c > s), l.setAttribute("aria-hidden", String(c !== s));
    });
  }), queueMicrotask(() => {
    if (o.signal.aborted) return;
    const s = Gn(t, e, Wn(n));
    s && (Jn(s, t, a, o.signal, i), Yn(s, t, a, n, i)), queueMicrotask(() => t.classList.add("panels-ready"));
  });
}, Kn = (t) => Array.from(t.children).filter((e) => e instanceof HTMLElement && !zn.has(e.tagName)), De = (t) => {
  const e = t.prefixed("accordion");
  return `[${e}], [${e}\\.open], [${e}\\.closed]`;
}, Wn = (t) => `[data-panel-trigger], ${De(t)}`, Zt = (t, e, n) => Array.from(t.querySelectorAll(n)).filter((i) => !e.contains(i)), Gn = (t, e, n) => {
  if (e) return t.closest(e) ?? document.querySelector(e);
  let i = t.parentElement;
  for (; i; ) {
    if (Zt(i, t, n).length) return i;
    if (i.tagName === "SECTION") return null;
    i = i.parentElement;
  }
  return null;
}, Yn = (t, e, n, i, r) => {
  Zt(t, e, De(i)).map((a) => i.evaluate(a, "$accordion")).forEach((a, o) => {
    a && r(() => {
      a.active && (n.index = o);
    });
  });
}, Jn = (t, e, n, i, r) => {
  const a = Zt(t, e, "[data-panel-trigger]");
  if (!a.length) return;
  const o = a.map((s) => [s.dataset.panelTriggerTarget === "parent" ? s.parentElement ?? s : s, s.dataset.panelTrigger ?? "hover"]);
  o.forEach(([s, l], c) => {
    const d = () => {
      n.index = c;
    };
    l === "click" ? s.addEventListener("click", d, { signal: i }) : l === "hover" ? (s.addEventListener("pointerenter", d, { signal: i }), s.addEventListener("focusin", d, { signal: i })) : console.error("x-panel-trigger action: ", l, " is invalid. Use 'hover' or 'click'.");
  }), r(() => {
    const s = n.index;
    o.forEach(([l], c) => l.classList.toggle("trigger-current", c === s));
  });
}, Xn = (t) => {
  t.data("productCard", (e) => ({
    variant: e,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: i, color: r } = this.variant;
      return {
        name: n,
        description: i,
        color: r
      };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, { variant: n });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    }
  }));
}, Pe = class extends Error {
}, Gt = /* @__PURE__ */ new Map(), Zn = (t) => typeof t == "string" ? t : t.name, Qn = (t, e) => {
  const n = Gt.get(t);
  if (n) return n;
  const i = window.Shopify?.routes?.root ?? "/", r = fetch(`${i}products/${t}?view=quickadd`).then((a) => {
    if (a.status === 404) throw new Pe(t);
    if (!a.ok) throw new Error(`Quick add: ${a.status}`);
    return a.json();
  }).then((a) => ({
    optionNames: a.options.map(Zn),
    variants: a.variants.map((o) => ({
      id: o.id,
      options: o.options,
      available: o.available,
      price: e(o.price / 100),
      label: o.label
    }))
  }));
  return r.catch(() => Gt.delete(t)), Gt.set(t, r), r;
}, ti = 500, ei = 5e3, ni = (t) => {
  t.data("quickAdd", (e) => ({
    text: e.text,
    title: e.title,
    label: e.label,
    soldOut: e.available === !1,
    handle: e.handle ?? null,
    variants: e.variants ?? [],
    optionNames: e.optionNames ?? [],
    open: !1,
    hasPanel: (e.variants ?? []).length > 1,
    step: 0,
    picked: [],
    busy: !1,
    pendingFocus: 0,
    loading: !1,
    status: "",
    error: "",
    requestId: 0,
    loadingTimer: 0,
    statusTimer: 0,
    get panelId() {
      return `quick-add-panel-${e.blockId}-${e.uid}`;
    },
    get scopeId() {
      return `shopify-block-${e.blockId}-${e.uid}`;
    },
    get loaded() {
      return this.variants.length > 0;
    },
    get isLast() {
      return this.step === this.optionNames.length - 1;
    },
    get optionName() {
      return this.optionNames[this.step] ?? "";
    },
    get panelLabel() {
      return this.optionName ? `${this.text.choose} — ${this.optionName}` : null;
    },
    get choices() {
      const n = this.variants.filter((r) => this.picked.every((a, o) => r.options[o] === a)), i = /* @__PURE__ */ new Map();
      return n.forEach((r) => {
        const a = r.options[this.step], o = i.get(a);
        if (o) {
          r.available && !o.available && Object.assign(o, {
            available: !0,
            id: r.id,
            price: r.price,
            label: this.labelFor(r, a)
          });
          return;
        }
        i.set(a, {
          value: a,
          options: r.options,
          available: r.available,
          id: r.id,
          price: r.price,
          label: this.labelFor(r, a)
        });
      }), this.withoutCollidingLabels(Array.from(i.values()));
    },
    labelFor(n, i) {
      return this.isLast && n.label || i;
    },
    withoutCollidingLabels(n) {
      const i = /* @__PURE__ */ new Map();
      return n.forEach((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        i.set(a, (i.get(a) ?? 0) + 1);
      }), n.map((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        return (i.get(a) ?? 0) < 2 ? r : {
          ...r,
          label: r.value
        };
      });
    },
    detail(n) {
      return n.available ? this.isLast ? n.price : "" : this.text.soldOut;
    },
    get alive() {
      return !!this.$root?.isConnected;
    },
    say(n) {
      window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
        this.alive && (this.status = n, n && (this.statusTimer = window.setTimeout(() => {
          this.status = "";
        }, ei)));
      });
    },
    focusMountedOption() {
      this.$nextTick(() => {
        this.alive && this.$refs.options?.querySelector("[data-quick-add-option]")?.focus();
      });
    },
    requestOptionFocus() {
      this.pendingFocus = this.requestId;
    },
    claimFocus(n) {
      this.pendingFocus && this.pendingFocus === this.requestId && this.open && this.$root?.contains(n) && (this.pendingFocus = 0, n.focus());
    },
    focusFirstOption() {
      if (this.$refs.options?.querySelector("[data-quick-add-option]")) {
        this.focusMountedOption();
        return;
      }
      this.requestOptionFocus();
    },
    reset() {
      this.step = 0, this.picked = [];
    },
    close(n) {
      this.open = !1, this.$refs.panel?.close(), this.pendingFocus = 0, this.reset(), n && this.alive && this.$refs.trigger?.focus();
    },
    back() {
      if (this.step === 0) {
        this.close(!0);
        return;
      }
      this.step = this.step - 1, this.picked = this.picked.slice(0, this.step), this.requestOptionFocus();
    },
    select(n) {
      if (n.available && this.loaded) {
        if (this.isLast) {
          this.add(n);
          return;
        }
        this.picked = this.picked.slice(0, this.step).concat(n.value), this.step = this.step + 1, this.requestOptionFocus();
      }
    },
    onEscape(n) {
      if (!this.open && !this.loading) return;
      n.stopPropagation();
      const i = this.open;
      this.requestId += 1, window.clearTimeout(this.loadingTimer), this.loading = !1, this.close(i || document.activeElement === document.body);
    },
    async ensureLoaded(n) {
      if (this.loaded) return !0;
      if (!this.handle) return !1;
      this.loading = !0, this.loadingTimer = window.setTimeout(() => {
        this.loading && this.requestId === n && this.say(this.text.loading);
      }, ti);
      try {
        const i = await Qn(this.handle, this.$formatMoney);
        return this.requestId !== n || !this.alive ? !1 : (this.optionNames = i.optionNames, this.variants = i.variants, !0);
      } catch (i) {
        return this.requestId !== n || !this.alive || (i instanceof Pe ? this.say(this.text.unavailable.replace("[product]", () => this.title)) : this.error = this.text.loadFailed.replace("[product]", () => this.title)), !1;
      } finally {
        window.clearTimeout(this.loadingTimer), this.loading = !1;
      }
    },
    async activate() {
      if (this.busy || this.soldOut) return;
      if (this.open) {
        this.close(!1);
        return;
      }
      this.busy = !0, this.error = "";
      const n = this.requestId += 1;
      try {
        if (!await this.ensureLoaded(n)) return;
        if (!this.variants.some((i) => i.available)) {
          this.soldOut = !0, this.say(this.text.soldOutProduct.replace("[product]", () => this.title));
          return;
        }
        if (this.variants.length === 1) {
          await this.addVariant(this.variants[0].id, this.title);
          return;
        }
        if (this.reset(), this.hasPanel = !0, await this.$nextTick(), this.requestId !== n || !this.alive) return;
        this.open = !0, this.$refs.panel?.show(), document.activeElement === this.$refs.trigger ? this.focusFirstOption() : this.say(`${this.title}. ${this.panelLabel ?? ""}`);
      } finally {
        this.busy = !1;
      }
    },
    get cart() {
      return this.$store.cart;
    },
    get itemCount() {
      return this.cart.data.item_count ?? 0;
    },
    async syncCart() {
      this.cart.data.items || (this.cart.data = await this.cart.getState());
    },
    async add(n) {
      if (!this.busy) {
        this.busy = !0;
        try {
          await this.addVariant(n.id, n.value);
        } finally {
          this.busy = !1;
        }
      }
    },
    async addVariant(n, i) {
      this.error = "", this.say(this.text.adding), await this.syncCart();
      const r = this.itemCount;
      if (await this.cart.addItem(n), !!this.alive) {
        if (this.itemCount === r) {
          this.error = this.text.failed;
          return;
        }
        this.say(this.text.added.replace("[variant]", () => i)), this.close(!0), this.cart.open();
      }
    },
    destroy() {
      window.clearTimeout(this.loadingTimer), window.clearTimeout(this.statusTimer);
    }
  }));
}, ii = (t) => {
  t.data("quickOrder", (e) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === e);
    },
    get quantity() {
      return this.productEntries.reduce((n, i) => n + i.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((n, i) => n + i.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), t.data("quickOrderRow", (e, n) => ({
    quantity: t.store("cart").items.find((i) => i.id === Number(e))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), t.data("quickQuantity", (e) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, ri = (t) => t.data("sizes", (e) => ({
  ...e,
  changeSize(n) {
    this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
  }
})), ai = (t) => {
  t.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const e = this.PDPATC.getBoundingClientRect();
      this.show = e.top < 25;
    }
  }));
}, oi = (t) => {
  t.addRootSelector(() => `[${t.prefixed("stickyheader")}]`), t.directive("stickyheader", (e, n, { cleanup: i }) => {
    console.log("checking sticky header");
    const r = e.closest("section");
    if (!r || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const a = new Animation(new KeyframeEffect(r, [{ top: "0px" }, { get top() {
      return `-${e.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    a.persist(), a.reverse(), a.finish();
    const o = t.effect(() => {
      const s = +(t.$scroll.direction === "down" && !t.$scroll.nearTop && !t.store("search").isOpen);
      a.playbackRate = s * 2 - 1;
    });
    i(() => t.release(o));
  });
}, si = [
  mn,
  gn,
  yn,
  Nn,
  Mn,
  bn,
  Tn,
  kn,
  In,
  Cn,
  jn,
  Bn,
  Vn,
  qn,
  Hn,
  Xn,
  ni,
  ii,
  ri,
  ai,
  oi
], Lt = Math.min, nt = Math.max, _t = Math.round, kt = Math.floor, X = (t) => ({
  x: t,
  y: t
}), li = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ci = {
  start: "end",
  end: "start"
};
function ae(t, e, n) {
  return nt(t, Lt(e, n));
}
function jt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function it(t) {
  return t.split("-")[0];
}
function Bt(t) {
  return t.split("-")[1];
}
function Me(t) {
  return t === "x" ? "y" : "x";
}
function je(t) {
  return t === "y" ? "height" : "width";
}
function Vt(t) {
  return ["top", "bottom"].includes(it(t)) ? "y" : "x";
}
function Be(t) {
  return Me(Vt(t));
}
function ui(t, e, n) {
  n === void 0 && (n = !1);
  const i = Bt(t), r = Be(t), a = je(r);
  let o = r === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (o = Ft(o)), [o, Ft(o)];
}
function di(t) {
  const e = Ft(t);
  return [
    Yt(t),
    e,
    Yt(e)
  ];
}
function Yt(t) {
  return t.replace(/start|end/g, (e) => ci[e]);
}
function fi(t, e, n) {
  const i = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? r : i : e ? i : r;
    case "left":
    case "right":
      return e ? a : o;
    default:
      return [];
  }
}
function hi(t, e, n, i) {
  const r = Bt(t);
  let a = fi(it(t), n === "start", i);
  return r && (a = a.map((o) => o + "-" + r), e && (a = a.concat(a.map(Yt)))), a;
}
function Ft(t) {
  return t.replace(/left|right|bottom|top/g, (e) => li[e]);
}
function pi(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function vi(t) {
  return typeof t != "number" ? pi(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function At(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function oe(t, e, n) {
  let { reference: i, floating: r } = t;
  const a = Vt(e), o = Be(e), s = je(o), l = it(e), c = a === "y", d = i.x + i.width / 2 - r.width / 2, u = i.y + i.height / 2 - r.height / 2, p = i[s] / 2 - r[s] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: d,
        y: i.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: i.y + i.height
      };
      break;
    case "right":
      v = {
        x: i.x + i.width,
        y: u
      };
      break;
    case "left":
      v = {
        x: i.x - r.width,
        y: u
      };
      break;
    default:
      v = {
        x: i.x,
        y: i.y
      };
  }
  switch (Bt(e)) {
    case "start":
      v[o] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      v[o] += p * (n && c ? -1 : 1);
  }
  return v;
}
var mi = async (t, e, n) => {
  const { placement: i = "bottom", strategy: r = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), { x: d, y: u } = oe(c, i, l), p = i, v = {}, g = 0;
  for (let y = 0; y < s.length; y++) {
    const { name: m, fn: x } = s[y], { x: N, y: O, data: $, reset: F } = await x({
      x: d,
      y: u,
      initialPlacement: i,
      placement: p,
      strategy: r,
      middlewareData: v,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (d = N ?? d, u = O ?? u, v = {
      ...v,
      [m]: {
        ...v[m],
        ...$
      }
    }, F && g <= 50) {
      g++, typeof F == "object" && (F.placement && (p = F.placement), F.rects && (c = F.rects === !0 ? await o.getElementRects({
        reference: t,
        floating: e,
        strategy: r
      }) : F.rects), { x: d, y: u } = oe(c, p, l)), y = -1;
      continue;
    }
  }
  return {
    x: d,
    y: u,
    placement: p,
    strategy: r,
    middlewareData: v
  };
};
async function Ve(t, e) {
  var n;
  e === void 0 && (e = {});
  const { x: i, y: r, platform: a, rects: o, elements: s, strategy: l } = t, { boundary: c = "clippingAncestors", rootBoundary: d = "viewport", elementContext: u = "floating", altBoundary: p = !1, padding: v = 0 } = jt(e, t), g = vi(v), y = s[p ? u === "floating" ? "reference" : "floating" : u], m = At(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), x = u === "floating" ? {
    ...o.floating,
    x: i,
    y: r
  } : o.reference, N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), O = await (a.isElement == null ? void 0 : a.isElement(N)) ? await (a.getScale == null ? void 0 : a.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = At(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: x,
    offsetParent: N,
    strategy: l
  }) : x);
  return {
    top: (m.top - $.top + g.top) / O.y,
    bottom: ($.bottom - m.bottom + g.bottom) / O.y,
    left: (m.left - $.left + g.left) / O.x,
    right: ($.right - m.right + g.right) / O.x
  };
}
var gi = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, i;
      const { placement: r, middlewareData: a, rects: o, initialPlacement: s, platform: l, elements: c } = e, { mainAxis: d = !0, crossAxis: u = !0, fallbackPlacements: p, fallbackStrategy: v = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: y = !0, ...m } = jt(t, e);
      if ((n = a.arrow) != null && n.alignmentOffset) return {};
      const x = it(r), N = it(s) === s, O = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), $ = p || (N || !y ? [Ft(s)] : di(s));
      !p && g !== "none" && $.push(...hi(s, y, g, O));
      const F = [s, ...$], R = await Ve(e, m), k = [];
      let _ = ((i = a.flip) == null ? void 0 : i.overflows) || [];
      if (d && k.push(R[x]), u) {
        const E = ui(r, o, O);
        k.push(R[E[0]], R[E[1]]);
      }
      if (_ = [..._, {
        placement: r,
        overflows: k
      }], !k.every((E) => E <= 0)) {
        var z, K;
        const E = (((z = a.flip) == null ? void 0 : z.index) || 0) + 1, f = F[E];
        if (f) return {
          data: {
            index: E,
            overflows: _
          },
          reset: { placement: f }
        };
        let h = (K = _.filter((b) => b.overflows[0] <= 0).sort((b, S) => b.overflows[1] - S.overflows[1])[0]) == null ? void 0 : K.placement;
        if (!h) switch (v) {
          case "bestFit": {
            var P;
            const b = (P = _.map((S) => [S.placement, S.overflows.filter((w) => w > 0).reduce((w, C) => w + C, 0)]).sort((S, w) => S[1] - w[1])[0]) == null ? void 0 : P[0];
            b && (h = b);
            break;
          }
          case "initialPlacement":
            h = s;
        }
        if (r !== h) return { reset: { placement: h } };
      }
      return {};
    }
  };
};
async function bi(t, e) {
  const { placement: n, platform: i, elements: r } = t, a = await (i.isRTL == null ? void 0 : i.isRTL(r.floating)), o = it(n), s = Bt(n), l = Vt(n) === "y", c = ["left", "top"].includes(o) ? -1 : 1, d = a && l ? -1 : 1, u = jt(e, t);
  let { mainAxis: p, crossAxis: v, alignmentAxis: g } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof g == "number" && (v = s === "end" ? g * -1 : g), l ? {
    x: v * d,
    y: p * c
  } : {
    x: p * c,
    y: v * d
  };
}
var yi = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const { x: n, y: i } = e, r = await bi(e, t);
      return {
        x: n + r.x,
        y: i + r.y,
        data: r
      };
    }
  };
}, wi = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const { x: n, y: i, placement: r } = e, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (m) => {
        let { x, y: N } = m;
        return {
          x,
          y: N
        };
      } }, ...l } = jt(t, e), c = {
        x: n,
        y: i
      }, d = await Ve(e, l), u = Vt(it(r)), p = Me(u);
      let v = c[p], g = c[u];
      if (a) {
        const m = p === "y" ? "top" : "left", x = p === "y" ? "bottom" : "right", N = v + d[m], O = v - d[x];
        v = ae(N, v, O);
      }
      if (o) {
        const m = u === "y" ? "top" : "left", x = u === "y" ? "bottom" : "right", N = g + d[m], O = g - d[x];
        g = ae(N, g, O);
      }
      const y = s.fn({
        ...e,
        [p]: v,
        [u]: g
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - i
        }
      };
    }
  };
};
function Z(t) {
  return qe(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function q(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Y(t) {
  var e;
  return (e = (qe(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function qe(t) {
  return t instanceof Node || t instanceof q(t).Node;
}
function G(t) {
  return t instanceof Element || t instanceof q(t).Element;
}
function U(t) {
  return t instanceof HTMLElement || t instanceof q(t).HTMLElement;
}
function se(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof q(t).ShadowRoot;
}
function St(t) {
  const { overflow: e, overflowX: n, overflowY: i, display: r } = H(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && !["inline", "contents"].includes(r);
}
function xi(t) {
  return [
    "table",
    "td",
    "th"
  ].includes(Z(t));
}
function Qt(t) {
  const e = te(), n = H(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((i) => (n.willChange || "").includes(i)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((i) => (n.contain || "").includes(i));
}
function Si(t) {
  let e = ut(t);
  for (; U(e) && !qt(e); ) {
    if (Qt(e)) return e;
    e = ut(e);
  }
  return null;
}
function te() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function qt(t) {
  return [
    "html",
    "body",
    "#document"
  ].includes(Z(t));
}
function H(t) {
  return q(t).getComputedStyle(t);
}
function Ht(t) {
  return G(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function ut(t) {
  if (Z(t) === "html") return t;
  const e = t.assignedSlot || t.parentNode || se(t) && t.host || Y(t);
  return se(e) ? e.host : e;
}
function He(t) {
  const e = ut(t);
  return qt(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : U(e) && St(e) ? e : He(e);
}
function gt(t, e, n) {
  var i;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = He(t), a = r === ((i = t.ownerDocument) == null ? void 0 : i.body), o = q(r);
  return a ? e.concat(o, o.visualViewport || [], St(r) ? r : [], o.frameElement && n ? gt(o.frameElement) : []) : e.concat(r, gt(r, [], n));
}
function ze(t) {
  const e = H(t);
  let n = parseFloat(e.width) || 0, i = parseFloat(e.height) || 0;
  const r = U(t), a = r ? t.offsetWidth : n, o = r ? t.offsetHeight : i, s = _t(n) !== a || _t(i) !== o;
  return s && (n = a, i = o), {
    width: n,
    height: i,
    $: s
  };
}
function ee(t) {
  return G(t) ? t : t.contextElement;
}
function ct(t) {
  const e = ee(t);
  if (!U(e)) return X(1);
  const n = e.getBoundingClientRect(), { width: i, height: r, $: a } = ze(e);
  let o = (a ? _t(n.width) : n.width) / i, s = (a ? _t(n.height) : n.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
var Ei = /* @__PURE__ */ X(0);
function Ue(t) {
  const e = q(t);
  return !te() || !e.visualViewport ? Ei : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Ti(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== q(t) ? !1 : e;
}
function rt(t, e, n, i) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), a = ee(t);
  let o = X(1);
  e && (i ? G(i) && (o = ct(i)) : o = ct(t));
  const s = Ti(a, n, i) ? Ue(a) : X(0);
  let l = (r.left + s.x) / o.x, c = (r.top + s.y) / o.y, d = r.width / o.x, u = r.height / o.y;
  if (a) {
    const p = q(a), v = i && G(i) ? q(i) : i;
    let g = p.frameElement;
    for (; g && i && v !== p; ) {
      const y = ct(g), m = g.getBoundingClientRect(), x = H(g), N = m.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, O = m.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      l *= y.x, c *= y.y, d *= y.x, u *= y.y, l += N, c += O, g = q(g).frameElement;
    }
  }
  return At({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function ki(t) {
  let { rect: e, offsetParent: n, strategy: i } = t;
  const r = U(n), a = Y(n);
  if (n === a) return e;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = X(1);
  const l = X(0);
  if ((r || !r && i !== "fixed") && ((Z(n) !== "body" || St(a)) && (o = Ht(n)), U(n))) {
    const c = rt(n);
    s = ct(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: e.width * s.x,
    height: e.height * s.y,
    x: e.x * s.x - o.scrollLeft * s.x + l.x,
    y: e.y * s.y - o.scrollTop * s.y + l.y
  };
}
function Ii(t) {
  return Array.from(t.getClientRects());
}
function Ke(t) {
  return rt(Y(t)).left + Ht(t).scrollLeft;
}
function Ci(t) {
  const e = Y(t), n = Ht(t), i = t.ownerDocument.body, r = nt(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), a = nt(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
  let o = -n.scrollLeft + Ke(t);
  const s = -n.scrollTop;
  return H(i).direction === "rtl" && (o += nt(e.clientWidth, i.clientWidth) - r), {
    width: r,
    height: a,
    x: o,
    y: s
  };
}
function Ni(t, e) {
  const n = q(t), i = Y(t), r = n.visualViewport;
  let a = i.clientWidth, o = i.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, o = r.height;
    const c = te();
    (!c || c && e === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function Oi(t, e) {
  const n = rt(t, !0, e === "fixed"), i = n.top + t.clientTop, r = n.left + t.clientLeft, a = U(t) ? ct(t) : X(1);
  return {
    width: t.clientWidth * a.x,
    height: t.clientHeight * a.y,
    x: r * a.x,
    y: i * a.y
  };
}
function le(t, e, n) {
  let i;
  if (e === "viewport") i = Ni(t, n);
  else if (e === "document") i = Ci(Y(t));
  else if (G(e)) i = Oi(e, n);
  else {
    const r = Ue(t);
    i = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return At(i);
}
function We(t, e) {
  const n = ut(t);
  return n === e || !G(n) || qt(n) ? !1 : H(n).position === "fixed" || We(n, e);
}
function Li(t, e) {
  const n = e.get(t);
  if (n) return n;
  let i = gt(t, [], !1).filter((s) => G(s) && Z(s) !== "body"), r = null;
  const a = H(t).position === "fixed";
  let o = a ? ut(t) : t;
  for (; G(o) && !qt(o); ) {
    const s = H(o), l = Qt(o);
    !l && s.position === "fixed" && (r = null), (a ? !l && !r : !l && s.position === "static" && r && ["absolute", "fixed"].includes(r.position) || St(o) && !l && We(t, o)) ? i = i.filter((c) => c !== o) : r = s, o = ut(o);
  }
  return e.set(t, i), i;
}
function _i(t) {
  let { element: e, boundary: n, rootBoundary: i, strategy: r } = t;
  const a = [...n === "clippingAncestors" ? Li(e, this._c) : [].concat(n), i], o = a[0], s = a.reduce((l, c) => {
    const d = le(e, c, r);
    return l.top = nt(d.top, l.top), l.right = Lt(d.right, l.right), l.bottom = Lt(d.bottom, l.bottom), l.left = nt(d.left, l.left), l;
  }, le(e, o, r));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Fi(t) {
  return ze(t);
}
function Ai(t, e, n) {
  const i = U(e), r = Y(e), a = n === "fixed", o = rt(t, !0, a, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = X(0);
  if (i || !i && !a)
    if ((Z(e) !== "body" || St(r)) && (s = Ht(e)), i) {
      const c = rt(e, !0, a, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else r && (l.x = Ke(r));
  return {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function ce(t, e) {
  return !U(t) || H(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Ge(t, e) {
  const n = q(t);
  if (!U(t)) return n;
  let i = ce(t, e);
  for (; i && xi(i) && H(i).position === "static"; ) i = ce(i, e);
  return i && (Z(i) === "html" || Z(i) === "body" && H(i).position === "static" && !Qt(i)) ? n : i || Si(t) || n;
}
var $i = async function(t) {
  let { reference: e, floating: n, strategy: i } = t;
  const r = this.getOffsetParent || Ge, a = this.getDimensions;
  return {
    reference: Ai(e, await r(n), i),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function Ri(t) {
  return H(t).direction === "rtl";
}
var Di = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ki,
  getDocumentElement: Y,
  getClippingRect: _i,
  getOffsetParent: Ge,
  getElementRects: $i,
  getClientRects: Ii,
  getDimensions: Fi,
  getScale: ct,
  isElement: G,
  isRTL: Ri
};
function Pi(t, e) {
  let n = null, i;
  const r = Y(t);
  function a() {
    clearTimeout(i), n && n.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const { left: c, top: d, width: u, height: p } = t.getBoundingClientRect();
    if (s || e(), !u || !p) return;
    const v = kt(d), g = kt(r.clientWidth - (c + u)), y = kt(r.clientHeight - (d + p)), m = kt(c), x = {
      rootMargin: -v + "px " + -g + "px " + -y + "px " + -m + "px",
      threshold: nt(0, Lt(1, l)) || 1
    };
    let N = !0;
    function O($) {
      const F = $[0].intersectionRatio;
      if (F !== l) {
        if (!N) return o();
        F ? o(!1, F) : i = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      N = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...x,
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, x);
    }
    n.observe(t);
  }
  return o(!0), a;
}
function Mi(t, e, n, i) {
  i === void 0 && (i = {});
  const { ancestorScroll: r = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: l = !1 } = i, c = ee(t), d = r || a ? [...c ? gt(c) : [], ...gt(e)] : [];
  d.forEach((x) => {
    r && x.addEventListener("scroll", n, { passive: !0 }), a && x.addEventListener("resize", n);
  });
  const u = c && s ? Pi(c, n) : null;
  let p = -1, v = null;
  o && (v = new ResizeObserver((x) => {
    let [N] = x;
    N && N.target === c && v && (v.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      v && v.observe(e);
    })), n();
  }), c && !l && v.observe(c), v.observe(e));
  let g, y = l ? rt(t) : null;
  l && m();
  function m() {
    const x = rt(t);
    y && (x.x !== y.x || x.y !== y.y || x.width !== y.width || x.height !== y.height) && n(), y = x, g = requestAnimationFrame(m);
  }
  return n(), () => {
    d.forEach((x) => {
      r && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), u && u(), v && v.disconnect(), v = null, l && cancelAnimationFrame(g);
  };
}
var ji = (t, e, n) => {
  const i = /* @__PURE__ */ new Map(), r = {
    platform: Di,
    ...n
  }, a = {
    ...r.platform,
    _c: i
  };
  return mi(t, e, {
    ...r,
    platform: a
  });
};
function Bi(t) {
  t.magic("anchor", (e) => {
    if (!e._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return e._x_anchor;
  }), t.interceptClone((e, n) => {
    e && e._x_anchor && !n._x_anchor && (n._x_anchor = e._x_anchor);
  }), t.directive("anchor", t.skipDuringClone((e, { expression: n, modifiers: i, value: r }, { evaluate: a, effect: o, cleanup: s }) => {
    let { placement: l, offsetValue: c, unstyled: d, strategy: u, allowFlip: p } = de(i);
    e._x_anchor = t.reactive({
      x: 0,
      y: 0
    });
    let v = null, g = null;
    o(() => {
      let y = a(n);
      if (y && v !== y) {
        g && g(), v = y;
        let m = () => {
          let x;
          ji(y, e, {
            placement: l,
            strategy: u,
            middleware: [
              p && gi(),
              wi({ padding: 5 }),
              yi(c)
            ]
          }).then(({ x: N, y: O }) => {
            d || ue(e, N, O, u), JSON.stringify({
              x: N,
              y: O
            }) !== x && (e._x_anchor.x = N, e._x_anchor.y = O), x = JSON.stringify({
              x: N,
              y: O
            });
          });
        };
        g = Mi(y, e, () => m());
      }
    }), s(() => {
      g && g();
    });
  }, (e, { expression: n, modifiers: i, value: r }, { cleanup: a, evaluate: o }) => {
    let { placement: s, offsetValue: l, unstyled: c, strategy: d } = de(i);
    e._x_anchor && (c || ue(e, e._x_anchor.x, e._x_anchor.y, d));
  }));
}
function ue(t, e, n, i = "absolute") {
  Object.assign(t.style, {
    left: e + "px",
    top: n + "px",
    position: i
  });
}
function de(t) {
  let e = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((o) => t.includes(o)), n = 0;
  if (t.includes("offset")) {
    let o = t.findIndex((s) => s === "offset");
    n = t[o + 1] !== void 0 ? Number(t[o + 1]) : n;
  }
  let i = t.includes("no-style"), r = !t.includes("noflip"), a = t.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: e,
    offsetValue: n,
    unstyled: i,
    strategy: a,
    allowFlip: r
  };
}
var Vi = Bi;
function qi(t) {
  t.directive("collapse", e), e.inline = (n, { modifiers: i }) => {
    i.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function e(n, { modifiers: i }) {
    let r = fe(i, "duration", 250) / 1e3, a = fe(i, "min", 0), o = !i.includes("min");
    n._x_isShown || (n.style.height = `${a}px`), !n._x_isShown && o && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let s = (c, d) => {
      let u = t.setStyles(c, d);
      return d.height ? () => {
      } : u;
    }, l = {
      transitionProperty: "height",
      transitionDuration: `${r}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(c = () => {
      }, d = () => {
      }) {
        o && (n.hidden = !1), o && (n.style.display = null);
        let u = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let p = n.getBoundingClientRect().height;
        u === p && (u = a), t.transition(n, t.setStyles, {
          during: l,
          start: { height: u + "px" },
          end: { height: p + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - p) < 1 && (n.style.overflow = null);
        });
      },
      out(c = () => {
      }, d = () => {
      }) {
        let u = n.getBoundingClientRect().height;
        t.transition(n, s, {
          during: l,
          start: { height: u + "px" },
          end: { height: a + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${a}px` && o && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function fe(t, e, n) {
  if (t.indexOf(e) === -1) return n;
  const i = t[t.indexOf(e) + 1];
  if (!i) return n;
  if (e === "duration") {
    let r = i.match(/([0-9]+)ms/);
    if (r) return r[1];
  }
  if (e === "min") {
    let r = i.match(/([0-9]+)px/);
    if (r) return r[1];
  }
  return i;
}
var Hi = qi, Ye = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], $t = /* @__PURE__ */ Ye.join(","), Je = typeof Element > "u", at = Je ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Rt = !Je && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, Dt = function(e, n) {
  var i;
  n === void 0 && (n = !0);
  var r = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "inert");
  return r === "" || r === "true" || n && e && (typeof e.closest == "function" ? e.closest("[inert]") : Dt(e.parentNode));
}, zi = function(e) {
  var n, i = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return i === "" || i === "true";
}, Xe = function(e, n, i) {
  if (Dt(e)) return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll($t));
  return n && at.call(e, $t) && r.unshift(e), r = r.filter(i), r;
}, Pt = function(e, n, i) {
  for (var r = [], a = Array.from(e); a.length; ) {
    var o = a.shift();
    if (!Dt(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), l = Pt(s.length ? s : o.children, !0, i);
        i.flatten ? r.push.apply(r, l) : r.push({
          scopeParent: o,
          candidates: l
        });
      } else {
        at.call(o, $t) && i.filter(o) && (n || !e.includes(o)) && r.push(o);
        var c = o.shadowRoot || typeof i.getShadowRoot == "function" && i.getShadowRoot(o), d = !Dt(c, !1) && (!i.shadowRootFilter || i.shadowRootFilter(o));
        if (c && d) {
          var u = Pt(c === !0 ? o.children : c.children, !0, i);
          i.flatten ? r.push.apply(r, u) : r.push({
            scopeParent: o,
            candidates: u
          });
        } else a.unshift.apply(a, o.children);
      }
  }
  return r;
}, Ze = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, et = function(e) {
  if (!e) throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || zi(e)) && !Ze(e) ? 0 : e.tabIndex;
}, Ui = function(e, n) {
  var i = et(e);
  return i < 0 && n && !Ze(e) ? 0 : i;
}, Ki = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, Qe = function(e) {
  return e.tagName === "INPUT";
}, Wi = function(e) {
  return Qe(e) && e.type === "hidden";
}, Gi = function(e) {
  return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
}, Yi = function(e, n) {
  for (var i = 0; i < e.length; i++) if (e[i].checked && e[i].form === n) return e[i];
}, Ji = function(e) {
  if (!e.name) return !0;
  var n = e.form || Rt(e), i = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") r = i(window.CSS.escape(e.name));
  else try {
    r = i(e.name);
  } catch (o) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
  }
  var a = Yi(r, e.form);
  return !a || a === e;
}, Xi = function(e) {
  return Qe(e) && e.type === "radio";
}, Zi = function(e) {
  return Xi(e) && !Ji(e);
}, Qi = function(e) {
  var n, i = e && Rt(e), r = (n = i) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (i && i !== e) {
    var o, s, l;
    for (a = !!((o = r) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(r) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !a && r; ) {
      var c, d, u;
      i = Rt(r), r = (c = i) === null || c === void 0 ? void 0 : c.host, a = !!((d = r) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(r));
    }
  }
  return a;
}, he = function(e) {
  var n = e.getBoundingClientRect(), i = n.width, r = n.height;
  return i === 0 && r === 0;
}, tr = function(e, n) {
  var i = n.displayCheck, r = n.getShadowRoot;
  if (i === "full-native" && "checkVisibility" in e)
    return !e.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(e).visibility === "hidden") return !0;
  var a = at.call(e, "details>summary:first-of-type") ? e.parentElement : e;
  if (at.call(a, "details:not([open]) *")) return !0;
  if (!i || i === "full" || i === "full-native" || i === "legacy-full") {
    if (typeof r == "function") {
      for (var o = e; e; ) {
        var s = e.parentElement, l = Rt(e);
        if (s && !s.shadowRoot && r(s) === !0) return he(e);
        e.assignedSlot ? e = e.assignedSlot : !s && l !== e.ownerDocument ? e = l.host : e = s;
      }
      e = o;
    }
    if (Qi(e)) return !e.getClientRects().length;
    if (i !== "legacy-full") return !0;
  } else if (i === "non-zero-area") return he(e);
  return !1;
}, er = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var i = 0; i < n.children.length; i++) {
          var r = n.children.item(i);
          if (r.tagName === "LEGEND") return at.call(n, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Mt = function(e, n) {
  return !(n.disabled || Wi(n) || tr(n, e) || Gi(n) || er(n));
}, Jt = function(e, n) {
  return !(Zi(n) || et(n) < 0 || !Mt(e, n));
}, nr = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, tn = function(e) {
  var n = [], i = [];
  return e.forEach(function(r, a) {
    var o = !!r.scopeParent, s = o ? r.scopeParent : r, l = Ui(s, o), c = o ? tn(r.candidates) : s;
    l === 0 ? o ? n.push.apply(n, c) : n.push(s) : i.push({
      documentOrder: a,
      tabIndex: l,
      item: r,
      isScope: o,
      content: c
    });
  }), i.sort(Ki).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(n);
}, ir = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = Pt([e], n.includeContainer, {
    filter: Jt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: nr
  }) : i = Xe(e, n.includeContainer, Jt.bind(null, n)), tn(i);
}, en = function(e, n) {
  n = n || {};
  var i;
  return n.getShadowRoot ? i = Pt([e], n.includeContainer, {
    filter: Mt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : i = Xe(e, n.includeContainer, Mt.bind(null, n)), i;
}, st = function(e, n) {
  if (n = n || {}, !e) throw new Error("No node provided");
  return at.call(e, $t) === !1 ? !1 : Jt(n, e);
}, rr = /* @__PURE__ */ Ye.concat("iframe:not([inert]):not([inert] *)").join(","), Ct = function(e, n) {
  if (n = n || {}, !e) throw new Error("No node provided");
  return at.call(e, rr) === !1 ? !1 : Mt(n, e);
};
function Xt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, i = Array(e); n < e; n++) i[n] = t[n];
  return i;
}
function ar(t) {
  if (Array.isArray(t)) return Xt(t);
}
function pe(t, e, n, i, r, a, o) {
  try {
    var s = t[a](o), l = s.value;
  } catch (c) {
    n(c);
    return;
  }
  s.done ? e(l) : Promise.resolve(l).then(i, r);
}
function ve(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(i, r) {
      var a = t.apply(e, n);
      function o(l) {
        pe(a, i, r, o, s, "next", l);
      }
      function s(l) {
        pe(a, i, r, o, s, "throw", l);
      }
      o(void 0);
    });
  };
}
function me(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = nn(t)) || e) {
      n && (t = n);
      var i = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return i >= t.length ? { done: !0 } : {
            done: !1,
            value: t[i++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var l = n.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, a = l;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function or(t, e, n) {
  return (e = dr(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function sr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function lr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ge(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function be(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ge(Object(n), !0).forEach(function(i) {
      or(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ge(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function vt() {
  var t, e, n = typeof Symbol == "function" ? Symbol : {}, i = n.iterator || "@@iterator", r = n.toStringTag || "@@toStringTag";
  function a(v, g, y, m) {
    var x = g && g.prototype instanceof s ? g : s, N = Object.create(x.prototype);
    return V(N, "_invoke", (function(O, $, F) {
      var R, k, _, z = 0, K = F || [], P = !1, E = {
        p: 0,
        n: 0,
        v: t,
        a: f,
        f: f.bind(t, 4),
        d: function(h, b) {
          return R = h, k = 0, _ = t, E.n = b, o;
        }
      };
      function f(h, b) {
        for (k = h, _ = b, e = 0; !P && z && !S && e < K.length; e++) {
          var S, w = K[e], C = E.p, T = w[2];
          h > 3 ? (S = T === b) && (_ = w[(k = w[4]) ? 5 : (k = 3, 3)], w[4] = w[5] = t) : w[0] <= C && ((S = h < 2 && C < w[1]) ? (k = 0, E.v = b, E.n = w[1]) : C < T && (S = h < 3 || w[0] > b || b > T) && (w[4] = h, w[5] = b, E.n = T, k = 0));
        }
        if (S || h > 1) return o;
        throw P = !0, b;
      }
      return function(h, b, S) {
        if (z > 1) throw TypeError("Generator is already running");
        for (P && b === 1 && f(b, S), k = b, _ = S; (e = k < 2 ? t : _) || !P; ) {
          R || (k ? k < 3 ? (k > 1 && (E.n = -1), f(k, _)) : E.n = _ : E.v = _);
          try {
            if (z = 2, R) {
              if (k || (h = "next"), e = R[h]) {
                if (!(e = e.call(R, _))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                _ = e.value, k < 2 && (k = 0);
              } else k === 1 && (e = R.return) && e.call(R), k < 2 && (_ = TypeError("The iterator does not provide a '" + h + "' method"), k = 1);
              R = t;
            } else if ((e = (P = E.n < 0) ? _ : O.call($, E)) !== o) break;
          } catch (w) {
            R = t, k = 1, _ = w;
          } finally {
            z = 1;
          }
        }
        return {
          value: e,
          done: P
        };
      };
    })(v, y, m), !0), N;
  }
  var o = {};
  function s() {
  }
  function l() {
  }
  function c() {
  }
  e = Object.getPrototypeOf;
  var d = [][i] ? e(e([][i]())) : (V(e = {}, i, function() {
    return this;
  }), e), u = c.prototype = s.prototype = Object.create(d);
  function p(v) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(v, c) : (v.__proto__ = c, V(v, r, "GeneratorFunction")), v.prototype = Object.create(u), v;
  }
  return l.prototype = c, V(u, "constructor", c), V(c, "constructor", l), l.displayName = "GeneratorFunction", V(c, r, "GeneratorFunction"), V(u), V(u, r, "Generator"), V(u, i, function() {
    return this;
  }), V(u, "toString", function() {
    return "[object Generator]";
  }), (vt = function() {
    return {
      w: a,
      m: p
    };
  })();
}
function V(t, e, n, i) {
  var r = Object.defineProperty;
  try {
    r({}, "", {});
  } catch {
    r = 0;
  }
  V = function(a, o, s, l) {
    function c(d, u) {
      V(a, d, function(p) {
        return this._invoke(d, u, p);
      });
    }
    o ? r ? r(a, o, {
      value: s,
      enumerable: !l,
      configurable: !l,
      writable: !l
    }) : a[o] = s : (c("next", 0), c("throw", 1), c("return", 2));
  }, V(t, e, n, i);
}
function cr(t) {
  return ar(t) || sr(t) || nn(t) || lr();
}
function ur(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e);
    if (typeof i != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function dr(t) {
  var e = ur(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function nn(t, e) {
  if (t) {
    if (typeof t == "string") return Xt(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xt(t, e) : void 0;
  }
}
var W = {
  getActiveTrap: function(e) {
    return e?.length > 0 ? e[e.length - 1] : null;
  },
  activateTrap: function(e, n) {
    n !== W.getActiveTrap(e) && W.pauseTrap(e);
    var i = e.indexOf(n);
    i === -1 || e.splice(i, 1), e.push(n);
  },
  deactivateTrap: function(e, n) {
    var i = e.indexOf(n);
    i !== -1 && e.splice(i, 1), W.unpauseTrap(e);
  },
  pauseTrap: function(e) {
    var n = W.getActiveTrap(e);
    n?._setPausedState(!0);
  },
  unpauseTrap: function(e) {
    var n = W.getActiveTrap(e);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, fr = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, hr = function(e) {
  return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, mt = function(e) {
  return e?.key === "Tab" || e?.keyCode === 9;
}, pr = function(e) {
  return mt(e) && !e.shiftKey;
}, vr = function(e) {
  return mt(e) && e.shiftKey;
}, ye = function(e) {
  return setTimeout(e, 0);
}, ft = function(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) i[r - 1] = arguments[r];
  return typeof e == "function" ? e.apply(void 0, i) : e;
}, It = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, mr = [], gr = function(e, n) {
  var i = n?.document || document, r = n?.trapStack || mr, a = be({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: pr,
    isKeyBackward: vr
  }, n), o = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, s, l = function(f, h, b) {
    return f && f[h] !== void 0 ? f[h] : a[b || h];
  }, c = function(f, h) {
    var b = typeof h?.composedPath == "function" ? h.composedPath() : void 0;
    return o.containerGroups.findIndex(function(S) {
      var w = S.container, C = S.tabbableNodes;
      return w.contains(f) || b?.includes(w) || C.find(function(T) {
        return T === f;
      });
    });
  }, d = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = h.hasFallback, S = b === void 0 ? !1 : b, w = h.params, C = w === void 0 ? [] : w, T = a[f];
    if (typeof T == "function" && (T = T.apply(void 0, cr(C))), T === !0 && (T = void 0), !T) {
      if (T === void 0 || T === !1) return T;
      throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
    }
    var I = T;
    if (typeof T == "string") {
      try {
        I = i.querySelector(T);
      } catch (L) {
        throw new Error("`".concat(f, '` appears to be an invalid selector; error="').concat(L.message, '"'));
      }
      if (!I && !S)
        throw new Error("`".concat(f, "` as selector refers to no known node"));
    }
    return I;
  }, u = function() {
    var f = d("initialFocus", { hasFallback: !0 });
    if (f === !1) return !1;
    if (f === void 0 || f && !Ct(f, a.tabbableOptions))
      if (c(i.activeElement) >= 0) f = i.activeElement;
      else {
        var h = o.tabbableGroups[0];
        f = h && h.firstTabbableNode || d("fallbackFocus");
      }
    else f === null && (f = d("fallbackFocus"));
    if (!f) throw new Error("Your focus-trap needs to have at least one focusable element");
    return f;
  }, p = function() {
    if (o.containerGroups = o.containers.map(function(f) {
      var h = ir(f, a.tabbableOptions), b = en(f, a.tabbableOptions), S = h.length > 0 ? h[0] : void 0, w = h.length > 0 ? h[h.length - 1] : void 0, C = b.find(function(I) {
        return st(I);
      }), T = b.slice().reverse().find(function(I) {
        return st(I);
      });
      return {
        container: f,
        tabbableNodes: h,
        focusableNodes: b,
        posTabIndexesFound: !!h.find(function(I) {
          return et(I) > 0;
        }),
        firstTabbableNode: S,
        lastTabbableNode: w,
        firstDomTabbableNode: C,
        lastDomTabbableNode: T,
        nextTabbableNode: function(L) {
          var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, B = h.indexOf(L);
          return B < 0 ? j ? b.slice(b.indexOf(L) + 1).find(function(D) {
            return st(D);
          }) : b.slice(0, b.indexOf(L)).reverse().find(function(D) {
            return st(D);
          }) : h[B + (j ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(f) {
      return f.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !d("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(f) {
      return f.posTabIndexesFound;
    }) && o.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function(f) {
    var h = f.activeElement;
    if (h)
      return h.shadowRoot && h.shadowRoot.activeElement !== null ? v(h.shadowRoot) : h;
  }, g = function(f) {
    if (f !== !1 && f !== v(document)) {
      if (!f || !f.focus) {
        g(u());
        return;
      }
      f.focus({ preventScroll: !!a.preventScroll }), o.mostRecentlyFocusedNode = f, fr(f) && f.select();
    }
  }, y = function(f) {
    var h = d("setReturnFocus", { params: [f] });
    return h || (h === !1 ? !1 : f);
  }, m = function(f) {
    var h = f.target, b = f.event, S = f.isBackward, w = S === void 0 ? !1 : S;
    h = h || It(b), p();
    var C = null;
    if (o.tabbableGroups.length > 0) {
      var T = c(h, b), I = T >= 0 ? o.containerGroups[T] : void 0;
      if (T < 0)
        w ? C = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : C = o.tabbableGroups[0].firstTabbableNode;
      else if (w) {
        var L = o.tabbableGroups.findIndex(function(Ut) {
          var Kt = Ut.firstTabbableNode;
          return h === Kt;
        });
        if (L < 0 && (I.container === h || Ct(h, a.tabbableOptions) && !st(h, a.tabbableOptions) && !I.nextTabbableNode(h, !1)) && (L = T), L >= 0) {
          var j = L === 0 ? o.tabbableGroups.length - 1 : L - 1, B = o.tabbableGroups[j];
          C = et(h) >= 0 ? B.lastTabbableNode : B.lastDomTabbableNode;
        } else mt(b) || (C = I.nextTabbableNode(h, !1));
      } else {
        var D = o.tabbableGroups.findIndex(function(Ut) {
          var Kt = Ut.lastTabbableNode;
          return h === Kt;
        });
        if (D < 0 && (I.container === h || Ct(h, a.tabbableOptions) && !st(h, a.tabbableOptions) && !I.nextTabbableNode(h)) && (D = T), D >= 0) {
          var zt = D === o.tabbableGroups.length - 1 ? 0 : D + 1, J = o.tabbableGroups[zt];
          C = et(h) >= 0 ? J.firstTabbableNode : J.firstDomTabbableNode;
        } else mt(b) || (C = I.nextTabbableNode(h));
      }
    } else C = d("fallbackFocus");
    return C;
  }, x = function(f) {
    if (!(c(It(f), f) >= 0)) {
      if (ft(a.clickOutsideDeactivates, f)) {
        s.deactivate({ returnFocus: a.returnFocusOnDeactivate });
        return;
      }
      ft(a.allowOutsideClick, f) || f.preventDefault();
    }
  }, N = function(f) {
    var h = It(f), b = c(h, f) >= 0;
    if (b || h instanceof Document)
      b && (o.mostRecentlyFocusedNode = h);
    else {
      f.stopImmediatePropagation();
      var S, w = !0;
      if (o.mostRecentlyFocusedNode)
        if (et(o.mostRecentlyFocusedNode) > 0) {
          var C = c(o.mostRecentlyFocusedNode), T = o.containerGroups[C].tabbableNodes;
          if (T.length > 0) {
            var I = T.findIndex(function(L) {
              return L === o.mostRecentlyFocusedNode;
            });
            I >= 0 && (a.isKeyForward(o.recentNavEvent) ? I + 1 < T.length && (S = T[I + 1], w = !1) : I - 1 >= 0 && (S = T[I - 1], w = !1));
          }
        } else o.containerGroups.some(function(L) {
          return L.tabbableNodes.some(function(j) {
            return et(j) > 0;
          });
        }) || (w = !1);
      else w = !1;
      w && (S = m({
        target: o.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(o.recentNavEvent)
      })), g(S || o.mostRecentlyFocusedNode || u());
    }
    o.recentNavEvent = void 0;
  }, O = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = f;
    var b = m({
      event: f,
      isBackward: h
    });
    b && (mt(f) && f.preventDefault(), g(b));
  }, $ = function(f) {
    (a.isKeyForward(f) || a.isKeyBackward(f)) && O(f, a.isKeyBackward(f));
  }, F = function(f) {
    hr(f) && ft(a.escapeDeactivates, f) !== !1 && (f.preventDefault(), s.deactivate());
  }, R = function(f) {
    c(It(f), f) >= 0 || ft(a.clickOutsideDeactivates, f) || ft(a.allowOutsideClick, f) || (f.preventDefault(), f.stopImmediatePropagation());
  }, k = function() {
    if (!o.active) return Promise.resolve();
    W.activateTrap(r, s);
    var f;
    return a.delayInitialFocus ? f = new Promise(function(h) {
      o.delayInitialFocusTimer = ye(function() {
        g(u()), h();
      });
    }) : (f = Promise.resolve(), g(u())), i.addEventListener("focusin", N, !0), i.addEventListener("mousedown", x, {
      capture: !0,
      passive: !1
    }), i.addEventListener("touchstart", x, {
      capture: !0,
      passive: !1
    }), i.addEventListener("click", R, {
      capture: !0,
      passive: !1
    }), i.addEventListener("keydown", $, {
      capture: !0,
      passive: !1
    }), i.addEventListener("keydown", F), f;
  }, _ = function(f) {
    o.active && !o.paused && s._setSubtreeIsolation(!1), o.adjacentElements.clear(), o.alreadySilent.clear();
    var h = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), S = me(f), w;
    try {
      for (S.s(); !(w = S.n()).done; ) {
        var C = w.value;
        h.add(C);
        for (var T = typeof ShadowRoot < "u" && C.getRootNode() instanceof ShadowRoot, I = C; I; ) {
          h.add(I);
          var L = I.parentElement, j = [];
          L ? j = L.children : !L && T && (j = I.getRootNode().children, L = I.getRootNode().host, T = typeof ShadowRoot < "u" && L.getRootNode() instanceof ShadowRoot);
          var B = me(j), D;
          try {
            for (B.s(); !(D = B.n()).done; ) {
              var zt = D.value;
              b.add(zt);
            }
          } catch (J) {
            B.e(J);
          } finally {
            B.f();
          }
          I = L;
        }
      }
    } catch (J) {
      S.e(J);
    } finally {
      S.f();
    }
    h.forEach(function(J) {
      b.delete(J);
    }), o.adjacentElements = b;
  }, z = function() {
    if (o.active)
      return i.removeEventListener("focusin", N, !0), i.removeEventListener("mousedown", x, !0), i.removeEventListener("touchstart", x, !0), i.removeEventListener("click", R, !0), i.removeEventListener("keydown", $, !0), i.removeEventListener("keydown", F), s;
  }, K = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(f) {
    f.some(function(h) {
      return Array.from(h.removedNodes).some(function(b) {
        return b === o.mostRecentlyFocusedNode;
      });
    }) && g(u());
  }) : void 0, P = function() {
    K && (K.disconnect(), o.active && !o.paused && o.containers.map(function(f) {
      K.observe(f, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(f) {
      if (o.active) return this;
      var h = l(f, "onActivate"), b = l(f, "onPostActivate"), S = l(f, "checkCanFocusTrap"), w = W.getActiveTrap(r), C = !1;
      if (w && !w.paused) {
        var T;
        (T = w._setSubtreeIsolation) === null || T === void 0 || T.call(w, !1), C = !0;
      }
      try {
        S || p(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = v(i), h?.();
        var I = /* @__PURE__ */ (function() {
          var j = ve(/* @__PURE__ */ vt().m(function B() {
            return vt().w(function(D) {
              for (; ; ) switch (D.n) {
                case 0:
                  return S && p(), D.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), P(), b?.();
                case 2:
                  return D.a(2);
              }
            }, B);
          }));
          return function() {
            return j.apply(this, arguments);
          };
        })();
        if (S)
          return S(o.containers.concat()).then(I, I), this;
        I();
      } catch (j) {
        if (w === W.getActiveTrap(r) && C) {
          var L;
          (L = w._setSubtreeIsolation) === null || L === void 0 || L.call(w, !0);
        }
        throw j;
      }
      return this;
    },
    deactivate: function(f) {
      if (!o.active) return this;
      var h = be({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, f);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, o.paused || s._setSubtreeIsolation(!1), o.alreadySilent.clear(), z(), o.active = !1, o.paused = !1, P(), W.deactivateTrap(r, s);
      var b = l(h, "onDeactivate"), S = l(h, "onPostDeactivate"), w = l(h, "checkCanReturnFocus"), C = l(h, "returnFocus", "returnFocusOnDeactivate");
      b?.();
      var T = function() {
        ye(function() {
          C && g(y(o.nodeFocusedBeforeActivation)), S?.();
        });
      };
      return C && w ? (w(y(o.nodeFocusedBeforeActivation)).then(T, T), this) : (T(), this);
    },
    pause: function(f) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, f)) : this;
    },
    unpause: function(f) {
      return o.active ? (o.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, f)) : this;
    },
    updateContainerElements: function(f) {
      return o.containers = [].concat(f).filter(Boolean).map(function(h) {
        return typeof h == "string" ? i.querySelector(h) : h;
      }), a.isolateSubtrees && _(o.containers), o.active && (p(), o.paused || s._setSubtreeIsolation(!0)), P(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: { value: function() {
      return o.manuallyPaused;
    } },
    _setPausedState: { value: function(f, h) {
      if (o.paused === f) return this;
      if (o.paused = f, f) {
        var b = l(h, "onPause"), S = l(h, "onPostPause");
        b?.(), z(), s._setSubtreeIsolation(!1), P(), S?.();
      } else {
        var w = l(h, "onUnpause"), C = l(h, "onPostUnpause");
        w?.(), (/* @__PURE__ */ (function() {
          var T = ve(/* @__PURE__ */ vt().m(function I() {
            return vt().w(function(L) {
              for (; ; ) switch (L.n) {
                case 0:
                  return p(), L.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), P(), C?.();
                case 2:
                  return L.a(2);
              }
            }, I);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(f) {
      a.isolateSubtrees && o.adjacentElements.forEach(function(h) {
        var b;
        f ? a.isolateSubtrees === "aria-hidden" ? ((h.ariaHidden === "true" || ((b = h.getAttribute("aria-hidden")) === null || b === void 0 ? void 0 : b.toLowerCase()) === "true") && o.alreadySilent.add(h), h.setAttribute("aria-hidden", "true")) : ((h.inert || h.hasAttribute("inert")) && o.alreadySilent.add(h), h.setAttribute("inert", !0)) : o.alreadySilent.has(h) || (a.isolateSubtrees === "aria-hidden" ? h.removeAttribute("aria-hidden") : h.removeAttribute("inert"));
      });
    } }
  }), s.updateContainerElements(e), s;
};
function br(t) {
  let e, n;
  window.addEventListener("focusin", () => {
    e = n, n = document.activeElement;
  }), t.magic("focus", (i) => {
    let r = i;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(a) {
        return r = a, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(a) {
        return Ct(a);
      },
      previouslyFocused() {
        return e;
      },
      lastFocused() {
        return e;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(r) ? r : en(r, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(a) {
        let o = this.all();
        return o[0] && o[0].isSameNode(a);
      },
      isLast(a) {
        let o = this.all();
        return o.length && o.slice(-1)[0].isSameNode(a);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === a.length - 1 ? a[0] : a[a.indexOf(o) + 1];
      },
      getPrevious() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === 0 ? a.slice(-1)[0] : a[a.indexOf(o) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(a) {
        a && setTimeout(() => {
          a.hasAttribute("tabindex") || a.setAttribute("tabindex", "0"), a.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), t.directive("trap", t.skipDuringClone((i, { expression: r, modifiers: a }, { effect: o, evaluateLater: s, cleanup: l }) => {
    let c = s(r), d = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => i
    }, p = () => {
    };
    if (a.includes("noautofocus")) u.initialFocus = !1;
    else {
      let m = i.querySelector("[autofocus]");
      m && (u.initialFocus = m);
    }
    a.includes("inert") && (u.onPostActivate = () => {
      t.nextTick(() => {
        p = we(i);
      });
    });
    let v = gr(i, u), g = () => {
    };
    const y = () => {
      p(), p = () => {
      }, g(), g = () => {
      }, v.deactivate({ returnFocus: !a.includes("noreturn") });
    };
    o(() => c((m) => {
      d !== m && (m && !d && (a.includes("noscroll") && (g = yr()), setTimeout(() => {
        v.activate();
      }, 15)), !m && d && y(), d = !!m);
    })), l(y);
  }, (i, { expression: r, modifiers: a }, { evaluate: o }) => {
    a.includes("inert") && o(r) && we(i);
  }));
}
function we(t) {
  let e = [];
  return rn(t, (n) => {
    let i = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), e.push(() => i || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; e.length; ) e.pop()();
  };
}
function rn(t, e) {
  t.isSameNode(document.body) || !t.parentNode || Array.from(t.parentNode.children).forEach((n) => {
    n.isSameNode(t) ? rn(t.parentNode, e) : e(n);
  });
}
function yr() {
  let t = document.documentElement.style.overflow, e = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth, i = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", i && i !== "auto" ? () => {
    document.documentElement.style.overflow = t;
  } : (document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = t, document.documentElement.style.paddingRight = e;
  });
}
var wr = br;
function xr(t) {
  t.directive("intersect", t.skipDuringClone((e, { value: n, expression: i, modifiers: r }, { evaluateLater: a, cleanup: o }) => {
    let s = a(i), l = {
      rootMargin: Tr(r),
      threshold: Sr(r),
      root: r.includes("parent") ? e.parentElement : null
    }, c = new IntersectionObserver((d) => {
      d.forEach((u) => {
        u.isIntersecting !== (n === "leave") && (s(), r.includes("once") && c.disconnect());
      });
    }, l);
    c.observe(e), o(() => {
      c.disconnect();
    });
  }));
}
function Sr(t) {
  if (t.includes("full")) return 0.99;
  if (t.includes("half")) return 0.5;
  if (!t.includes("threshold")) return 0;
  let e = t[t.indexOf("threshold") + 1];
  return e === "100" ? 1 : e === "0" ? 0 : +`.${e}`;
}
function Er(t) {
  let e = t.match(/^(-?[0-9]+)(px|%)?$/);
  return e ? e[1] + (e[2] || "px") : void 0;
}
function Tr(t) {
  const e = "margin", n = "0px 0px 0px 0px", i = t.indexOf(e);
  if (i === -1) return n;
  let r = [];
  for (let a = 1; a < 5; a++) r.push(Er(t[i + a] || ""));
  return r = r.filter((a) => a !== void 0), r.length ? r.join(" ").trim() : n;
}
var kr = xr;
function ne(t, e, n) {
  on();
  let i = an(n), r = typeof e == "string" ? Nr(e) : e;
  return window.Alpine && window.Alpine.closestDataStack && !t._x_dataStack && (r._x_dataStack = window.Alpine.closestDataStack(t), r._x_dataStack && window.Alpine.cloneNode(t, r)), i.patch(t, r), t;
}
function Ir(t, e, n, i = {}) {
  on();
  let r = an(i), a = t.parentNode, o = new bt(t, e), s = typeof n == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", n), u;
  })() : n, l = document.createComment("[morph-start]"), c = document.createComment("[morph-end]");
  s.insertBefore(l, s.firstChild), s.appendChild(c);
  let d = new bt(l, c);
  window.Alpine && window.Alpine.closestDataStack && (s._x_dataStack = window.Alpine.closestDataStack(a), s._x_dataStack && window.Alpine.cloneNode(a, s)), r.patchChildren(o, d);
}
function an(t = {}) {
  let e = (r) => r.getAttribute("key"), n = () => {
  }, i = {
    key: t.key || e,
    lookahead: t.lookahead || !1,
    updating: t.updating || n,
    updated: t.updated || n,
    removing: t.removing || n,
    removed: t.removed || n,
    adding: t.adding || n,
    added: t.added || n
  };
  return i.patch = function(r, a) {
    if (i.differentElementNamesTypesOrKeys(r, a)) return i.swapElements(r, a);
    let o = !1, s = !1, l = (c) => i.skipUntilCondition = c;
    if (!Cr(i.updating, () => s = !0, l, r, a, () => o = !0)) {
      if (r.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(r, a), r._x_teleport && a._x_teleport && i.patch(r._x_teleport, a._x_teleport)), Or(a)) {
        i.patchNodeValue(r, a), i.updated(r, a);
        return;
      }
      o || i.patchAttributes(r, a), i.updated(r, a), s || i.patchChildren(r, a);
    }
  }, i.differentElementNamesTypesOrKeys = function(r, a) {
    return r.nodeType != a.nodeType || r.nodeName != a.nodeName || i.getKey(r) != i.getKey(a);
  }, i.swapElements = function(r, a) {
    if (ht(i.removing, r)) return;
    let o = a.cloneNode(!0);
    ht(i.adding, o) || (r.replaceWith(o), i.removed(r), i.added(o));
  }, i.patchNodeValue = function(r, a) {
    let o = a.nodeValue;
    r.nodeValue !== o && (r.nodeValue = o);
  }, i.patchAttributes = function(r, a) {
    if (r._x_transitioning || r._x_isShown && !a._x_isShown || !r._x_isShown && a._x_isShown) return;
    let o = Array.from(r.attributes), s = Array.from(a.attributes);
    for (let l = o.length - 1; l >= 0; l--) {
      let c = o[l].name;
      a.hasAttribute(c) || (c === "open" && r.nodeName === "DIALOG" && r.open ? r.close() : r.removeAttribute(c));
    }
    for (let l = s.length - 1; l >= 0; l--) {
      let c = s[l].name, d = s[l].value;
      r.getAttribute(c) !== d && r.setAttribute(c, d);
    }
  }, i.patchChildren = function(r, a) {
    let o = i.keyToMap(r.children), s = {}, l = Se(a), c = Se(r);
    for (; l; ) {
      Lr(l, c);
      let u = i.getKey(l), p = i.getKey(c);
      if (i.skipUntilCondition) {
        let m = !c || i.skipUntilCondition(c), x = !l || i.skipUntilCondition(l);
        if (m && x) i.skipUntilCondition = null;
        else {
          m || (c = c && M(r, c)), x || (l = l && M(a, l));
          continue;
        }
      }
      if (!c)
        if (u && s[u]) {
          let m = s[u];
          r.appendChild(m), c = m, p = i.getKey(c);
        } else {
          if (!ht(i.adding, l)) {
            let m = l.cloneNode(!0);
            r.appendChild(m), i.added(m);
          }
          l = M(a, l);
          continue;
        }
      let v = (m) => m && m.nodeType === 8 && m.textContent === "[if BLOCK]><![endif]", g = (m) => m && m.nodeType === 8 && m.textContent === "[if ENDBLOCK]><![endif]";
      if (v(l) && v(c)) {
        let m = 0, x = c;
        for (; c; ) {
          let k = M(r, c);
          if (v(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            c = k;
            break;
          }
          c = k;
        }
        let N = c;
        m = 0;
        let O = l;
        for (; l; ) {
          let k = M(a, l);
          if (v(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            l = k;
            break;
          }
          l = k;
        }
        let $ = l, F = new bt(x, N), R = new bt(O, $);
        i.patchChildren(F, R);
        continue;
      }
      if (c.nodeType === 1 && i.lookahead && !c.isEqualNode(l)) {
        let m = M(a, l), x = !1;
        for (; !x && m; )
          m.nodeType === 1 && c.isEqualNode(m) && (x = !0, c = i.addNodeBefore(r, l, c), p = i.getKey(c)), m = M(a, m);
      }
      if (u !== p) {
        if (!u && p) {
          s[p] = c, c = i.addNodeBefore(r, l, c), s[p].remove(), c = M(r, c), l = M(a, l);
          continue;
        }
        if (u && !p && o[u] && (c.replaceWith(o[u]), c = o[u], p = i.getKey(c)), u && p) {
          let m = o[u];
          if (m)
            s[p] = c, c.replaceWith(m), c = m, p = i.getKey(c);
          else {
            s[p] = c, c = i.addNodeBefore(r, l, c), s[p].remove(), c = M(r, c), l = M(a, l);
            continue;
          }
        }
      }
      let y = c && M(r, c);
      i.patch(c, l), c._x_lastRenderedEl && (y = M(r, c._x_lastRenderedEl)), l = l && M(a, l), c = y;
    }
    let d = [];
    for (; c; )
      ht(i.removing, c) || d.push(c), c = M(r, c);
    for (; d.length; ) {
      let u = d.shift();
      u.remove(), i.removed(u);
    }
  }, i.getKey = function(r) {
    return r && r.nodeType === 1 && i.key(r);
  }, i.keyToMap = function(r) {
    let a = {};
    for (let o of r) {
      let s = i.getKey(o);
      s && (a[s] = o);
    }
    return a;
  }, i.addNodeBefore = function(r, a, o) {
    if (!ht(i.adding, a)) {
      let s = a.cloneNode(!0);
      return r.insertBefore(s, o), i.added(s), s;
    }
    return a;
  }, i;
}
ne.step = () => {
};
ne.log = () => {
};
function ht(t, ...e) {
  let n = !1;
  return t(...e, () => n = !0), n;
}
function Cr(t, e, n, ...i) {
  let r = !1;
  return t(...i, () => r = !0, e, n), r;
}
var xe = !1;
function Nr(t) {
  const e = document.createElement("template");
  return e.innerHTML = t, e.content.firstElementChild;
}
function Or(t) {
  return t.nodeType === 3 || t.nodeType === 8;
}
var bt = class {
  constructor(t, e) {
    this.startComment = t, this.endComment = e;
  }
  get children() {
    let t = [], e = this.startComment.nextSibling;
    for (; e && e !== this.endComment; )
      t.push(e), e = e.nextSibling;
    return t;
  }
  appendChild(t) {
    this.endComment.before(t);
  }
  get firstChild() {
    let t = this.startComment.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  nextNode(t) {
    let e = t.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  insertBefore(t, e) {
    return e.before(t), t;
  }
};
function Se(t) {
  return t.firstChild;
}
function M(t, e) {
  let n;
  return t instanceof bt ? n = t.nextNode(e) : n = e.nextSibling, n;
}
function on() {
  if (xe) return;
  xe = !0;
  let t = Element.prototype.setAttribute, e = document.createElement("div");
  Element.prototype.setAttribute = function(i, r) {
    if (!i.includes("@")) return t.call(this, i, r);
    let a = r.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    e.innerHTML = `<span ${i}="${a}"></span>`;
    let o = e.firstElementChild.getAttributeNode(i);
    e.firstElementChild.removeAttributeNode(o), this.setAttributeNode(o);
  };
}
function Lr(t, e) {
  let n = e && e._x_bindings && e._x_bindings.id;
  n && t.setAttribute && (t.setAttribute("id", n), t.id = n);
}
function _r(t) {
  t.morph = ne, t.morphBetween = Ir;
}
var Fr = _r, Ar = (t, e) => {
  let n;
  const i = /* @__PURE__ */ new Set();
  return function(r, a) {
    n && clearTimeout(n), r.forEach(({ target: o }) => i.add(o)), n = setTimeout(() => {
      t(i, a), n = null;
    }, e);
  };
}, $r = (t) => {
  t.forEach((e) => Rr(e)), t.clear();
}, Rr = (t) => {
  const e = (o) => t.setAttribute("sizes", (o | 0) + "px");
  let n = 0, i = 0, r = t;
  for (; n < 100 && r; )
    n = r.offsetWidth, i = r.offsetHeight, r = r.parentNode;
  if (getComputedStyle(t).objectFit !== "cover") return e(n);
  const a = Number(t.getAttribute("width")) / Number(t.getAttribute("height"));
  if (!a || n / i >= a + 0.1) return e(n);
  e(i * a);
}, Q = new ResizeObserver(Ar($r, 800)), Ee = (t, e, n) => {
  if (e) return Pr(t);
  if (n) return Dr(t, n);
  throw new TypeError("Invalid options");
}, Dr = (t, e) => (t = new URL(t, document.baseURI).href, t.includes("localhost") ? () => t : (n) => (e + t).replace("{width}", String(n))), Pr = (t) => {
  if (t.includes("{width}")) return (e) => t.replaceAll("{width}", String(e));
  if (ke.test(t)) {
    const e = t.replace(ke, "_{width}x$1");
    return (n) => e.replaceAll("{width}", String(n));
  }
  return (e) => {
    const n = new URL(t, document.baseURI);
    return n.searchParams.set("width", String(e)), n.href;
  };
}, Mr = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], Te = (t, e = 1 / 0) => Mr.filter((n) => n <= e).map((n) => `${t(n)} ${n}w`).join(","), ke = /_\d+x(\.jpg|\.png)/;
function jr(t) {
  const { autoSize: e = !0, shopify: n = !1, maxSize: i = 0, cloudURL: r = "" } = Br(t) ?? {};
  return (a) => {
    a.directive("rias", (s, { expression: l }, { effect: c, evaluateLater: d, cleanup: u }) => {
      if (!(s instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => Q.unobserve(s)), !l) return e && Q.observe(s);
      const p = d(l);
      c(() => {
        p((v) => {
          if (!v || typeof v != "string") return;
          const g = Ee(v, n, r), y = i || Number(s.dataset.maxSize) || 1 / 0, m = g(Math.min(y, 360)), x = Te(g, y);
          a.mutateDom(() => {
            s.src = m, s.srcset = x, s.loading = s.loading == "eager" ? "eager" : "lazy", (e || s.dataset.sizes == "auto") && Q.observe(s);
          });
        });
      });
    });
    const o = {
      srcset(s) {
        return Te(Ee(s, n, r), i || 1 / 0);
      },
      observe: Q.observe.bind(Q),
      unobserve: Q.unobserve.bind(Q)
    };
    a.magic("rias", () => o);
  };
}
var Br = (t) => {
  if (typeof t == "string") return { cloudURL: `https://res.cloudinary.com/${t}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof t == "object") return {
    ...t,
    cloudURL: t.key ? `https://res.cloudinary.com/${t.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, Vr = (t) => {
  t.addRootSelector(() => `[${t.prefixed("data-async")}]`);
  const e = "data-async", n = t.prefixed("ignore"), i = {}, r = /* @__PURE__ */ new WeakSet(), a = (o, { expression: s }, { evaluateLater: l, evaluate: c, cleanup: d }) => {
    r.has(o) || (r.add(o), l(s)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const p = t.reactive(u), v = t.addScopeToNode(o, p);
      p.init && c(p.init), d(() => {
        p.destroy && c(p.destroy), v();
      }), delete o._x_ignore, o.removeAttribute(n), t.initTree(o);
    }, { scope: i }));
  };
  a.inline = (o, { expression: s }) => {
    r.has(o) || (o._x_ignore = !0, o.setAttribute(n, ""));
  }, t.directive(e, a).before("ignore"), t.asyncData = (o, s) => {
    i[o] = async (...l) => {
      const [c, d] = s.split("?");
      try {
        const u = await import(c);
        if (d && d in u) return u[d](...l);
        if (o in u) return u[o](...l);
        if (u.default && typeof u.default == "function") return u.default(...l);
        if (typeof u == "function") return u(...l);
        throw new Error(`Async Data: Module ${s} does not export a function named ${o}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", o, s), console.error(u), {};
      }
    };
  };
}, qr = (t) => {
  t.directive("clickable", (i, { expression: r }, { cleanup: a }) => {
    const o = i.querySelector(r || "a, button");
    if (!o) return console.warn(`x-clickable: No target found for selector ${r || "a, button"}`);
    const s = function(l) {
      const c = l.target;
      !(c instanceof HTMLElement) || e(c, i) !== i || n(o, l.constructor, l);
    };
    a(t.bind(i, {
      "@click": s,
      "@auxclick": s
    }));
  });
  const e = (i, r) => t.findClosest(i, (a) => a.matches("a, button, input, select") || a === r), n = (i, r = MouseEvent, a) => i.dispatchEvent(new r("click", a));
}, Hr = class {
  el;
  details;
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(t, e, n) {
    this.el = t, this.details = n, this.backdrop = e.backdrop, this.keyboard = e.keyboard;
  }
  withDetails(t) {
    return t && (this.details = t), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, zr = class extends EventTarget {
  Alpine;
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(t) {
    super(), this.Alpine = t;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(t, e) {
    if (t === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const n = this.availableDialogs.get(t) ?? null;
    return n ? (this.active = n, n.withDetails(e).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: n })), this) : (console.error(`Modal with id "${t}" does not exist`), this);
  }
  close(t) {
    const e = t ?? this.active;
    return e ? (e.close().then((n) => n === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: e })), this) : (console.log(t, e, "there is no active"), this);
  }
  setOptions(t) {
    return this.active && Object.assign(this.active, t), this;
  }
  isRegistered(t) {
    return this.availableDialogs.has(t);
  }
  unregister(t) {
    return this.availableDialogs.delete(t), this.active?.id === t && (this.active = null), this;
  }
  create(t, e, n) {
    const i = this.Alpine.reactive(new Hr(t, e, n));
    return this.availableDialogs.set(i.id, i), i;
  }
}, Ur = (t) => {
  const e = new zr(t);
  t.addRootSelector(() => `[${t.prefixed("dialog")}]`), t.directive("dialog", (n, { expression: i }, { evaluate: r, cleanup: a }) => {
    if (!(n instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", n);
    const o = n.id;
    console.assert(!!o, "x-dialog element must have an ID: %o", n);
    const { backdrop: s = !0, keyboard: l = !0 } = i ? r(i) : {}, c = e.create(n, {
      backdrop: s,
      keyboard: l
    });
    a(t.addScopeToNode(n, { $dialog: c })), a(e.unregister.bind(e, o)), a(t.bind(n, {
      "@click.self"() {
        c.backdrop && e.close(c);
      },
      "@cancel.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      "@dialog-closed.self"(d) {
        d.detail === c && c === e.active && (e.active = null, e.dispatchEvent(new CustomEvent("dialog-closed", { detail: c })));
      },
      "@keydown.escape.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": c.closing,
          "dialog-in backdrop:animate-fade-in": c.opening
        };
      }
    }));
  }), t.magic("dialogs", () => e), t.$dialogs = e;
}, Nt = /* @__PURE__ */ (function(t) {
  return t.Up = "up", t.Down = "down", t;
})(Nt || {}), Kr = (t) => {
  const e = /* @__PURE__ */ new Set(), n = t.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Nt.Up,
    onScroll: (r) => (e.add(r), () => e.delete(r))
  });
  let i;
  n.onScroll((r) => {
    const a = r.current > r.previous ? Nt.Down : Nt.Up;
    a !== n.direction ? i ??= setTimeout(() => n.direction = a, 200) : (clearTimeout(i), i = void 0);
  }), window.addEventListener("scroll", () => {
    n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, e.forEach((r) => r(n));
  }, { passive: !0 }), t.$scroll = n, t.magic("scroll", () => n);
}, A = /* @__PURE__ */ Symbol("$slider"), sn = (t) => A in t, Wr = {
  ":disabled"() {
    return this[A].isLast;
  },
  "x-on:click"() {
    this[A].next(this.$el);
  }
}, Gr = {
  ":disabled"() {
    return this[A].isFirst;
  },
  "x-on:click"() {
    this[A].prev(this.$el);
  }
}, Yr = (t) => ({
  ":disabled"() {
    return this[A].focusedIndex === t;
  },
  "x-on:click"() {
    this[A].scrollTo(t);
  }
}), Jr = {
  "x-on:mouseenter"() {
    this[A].pause();
  },
  "x-on:mouseleave"() {
    this[A].unpause();
  },
  "x-on:focusin"() {
    this[A].pause();
  },
  "x-on:focusout"() {
    this[A].unpause();
  }
}, Xr = { ":style"() {
  const t = this[A].focusedSize;
  return {
    maxHeight: t ? `${t}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, Zr = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const t = this[A];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const t = this[A];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[A].onLoad(this.$el);
  },
  "x-on:load"() {
    this[A].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const t = this[A], e = this.index, n = t.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": e > n,
      "slide-previous": e < n,
      "slide-current": e === n,
      "slide-visible": this.visible
    };
  }
}, Qr = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, ta = (t, e, n, { Alpine: i, cleanup: r }) => {
  const a = i.$data(e);
  if (!sn(a)) {
    console.error(`Element with ${n.original} needs to be inside an x-slider element`, e);
    return;
  }
  const o = a[A];
  if (o.components.set(t, e), t === "gallery") {
    const s = new AbortController();
    e.addEventListener("scroll", o.updateEdges.bind(o), {
      passive: !0,
      signal: s.signal
    }), r(() => s.abort()), o.updateEdges();
  }
}, tt = (t) => Array.from(t.children).flatMap((e) => getComputedStyle(e).display === "contents" ? tt(e) : e).filter((e) => e.nodeName !== "TEMPLATE" && getComputedStyle(e).display !== "none"), ea = (t, e) => {
  let n = 0, i = Number.POSITIVE_INFINITY;
  for (let r = 0; r < t.length; r++) {
    const a = Math.abs(t[r] - e);
    if (a >= i) return n;
    i = a, n = r;
  }
  return n;
}, na = (t, e, n, i = 1) => {
  const r = e - n;
  return {
    atStart: t <= i,
    atEnd: t >= r - i
  };
}, ia = (t) => t instanceof HTMLImageElement, ra = (t, { expression: e }, { evaluate: n, cleanup: i, Alpine: r }) => {
  const a = [];
  i(() => a.forEach((l) => l()));
  const o = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, e ? n(e) : {}), s = r.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!o.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (o.autoScroll) {
        const l = new aa(o.autoScroll).onTick((c) => {
          this.autoScrollPercentage = c;
        }).onFinish(() => {
          if (this.touched) return l.abort();
          if (this.paused) return;
          const c = this.components.get("gallery");
          c && this.scrollTo(En(this.focusedIndex + 1, tt(c).length));
        });
        a.push(() => l.abort());
      }
    },
    onLoad(l) {
      if (this.initialized || ia(l) && !l.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const c = this.components.get("gallery");
      c && (c.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(l, c = !0) {
      if (!this.initialized) return;
      const d = this.components.get("gallery");
      if (c && (!d || o.animated)) {
        this.focusedIndex = this.indexOfItem(l) ?? 0, this.focusedSize = l.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const l = this.components.get("gallery");
      if (!l) return;
      const c = tt(l), d = parseFloat(getComputedStyle(l).scrollPaddingLeft) || 0, u = c.map((v) => ot(HTMLElement, v)?.offsetLeft ?? 0), p = ea(u, l.scrollLeft + d);
      this.focusedIndex = p, this.focusedSize = ot(HTMLElement, c[p])?.clientHeight ?? t.clientHeight;
    },
    itemAtIndex(l) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = tt(c);
      let u = d[wn(l, d.length - 1)];
      if (u !== void 0) {
        for (let p = 0; p < o.scrollToDepth; p++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(l + 1) : u;
      }
    },
    indexOfItem(l) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = tt(c);
      for (let u = 0; u < d.length; u++) if (d[u].contains(l)) return u;
    },
    async scrollTo(l, c = 0, d = !1, u = !1) {
      const p = this.components.get("gallery");
      if (!p) return;
      const v = l instanceof Element ? l : this.itemAtIndex(l);
      if (!v) return;
      d && (this.touched = !0);
      const g = typeof l == "number" ? l : this.indexOfItem(v) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Sn()), u || o.animated ? this.focusedIndex = g : this.focusedIndex += Math.sign(g - this.focusedIndex), o.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), o.intoView ? v.scrollIntoView({
        behavior: "smooth",
        block: o.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (p.style.scrollBehavior = "auto"), p.scrollLeft = l === 0 ? 0 : (ot(HTMLElement, v)?.offsetLeft ?? 0) - c, u && (p.style.scrollBehavior = null)));
      const y = this.components.get("thumbnails");
      if (!y) return;
      const m = ot(HTMLElement, y.children[g]);
      m && y.scrollTo({
        top: m.offsetTop - (y.clientHeight - m.clientHeight) / 2,
        left: m.offsetLeft - (y.clientWidth - m.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const l = this.components.get("gallery");
      if (!l || o.animated) return;
      const { atStart: c, atEnd: d } = na(l.scrollLeft, l.scrollWidth, l.clientWidth);
      this.atStart = c, this.atEnd = d;
    },
    get isFirst() {
      return o.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const l = this.components.get("gallery");
      return l ? o.animated ? this.focusedIndex === tt(l).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const l = this.components.get("gallery");
      return l ? tt(l).length : 0;
    },
    next(l) {
      const c = this.getStepInfo(l);
      this.scrollTo(Math.max(0, this.focusedIndex + c), 10, !0);
    },
    prev(l) {
      const c = this.getStepInfo(l);
      this.scrollTo(Math.max(0, this.focusedIndex - c), 10, !0);
    },
    getStepInfo(l) {
      const c = getComputedStyle(l);
      let d = parseInt(c.getPropertyValue("--perpage") || "1");
      const u = c.getPropertyValue("--arrow-step").trim(), p = this.components.get("gallery");
      if (p && u === "view") {
        const v = ot(HTMLElement, this.itemAtIndex(0)), g = ot(HTMLElement, this.itemAtIndex(1)), y = v && g && v !== g ? Math.abs(g.offsetLeft - v.offsetLeft) : 0;
        y > 0 && (d = Math.max(1, Math.floor(p.clientWidth / y)));
      }
      return d;
    }
  });
  r.addScopeToNode(t, { [A]: s }), o.autoInitialize && s.init();
}, aa = class ln extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(e) {
    super(), this.duration = e, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (e) => {
    if (this.controller.signal.aborted) return;
    const n = e - this.lastTimestep;
    this.lastTimestep = e, this.currentTime += n, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(e) {
    return this.addEventListener("tick", () => e(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(e) {
    return this.addEventListener("just-finished", e, { signal: this.controller.signal }), this;
  }
  static fromSeconds(e) {
    return new ln(e * 1e3);
  }
}, oa = (t) => {
  t.addRootSelector(() => `[${t.prefixed("slider")}]`), t.directive("slider", (e, n, i) => {
    if (!n.value || n.value === "root") return ra(e, n, i);
    (n.value === "gallery" || n.value === "thumbnails") && ta(n.value, e, n, i);
  }), t.magic("slider", (e) => {
    const n = t.$data(e);
    if (sn(n)) return n[A];
  }), t.bind("$sliderDynamicHeight", Xr), t.bind("$sliderItem", Zr), t.bind("$sliderNext", Wr), t.bind("$sliderPrev", Gr), t.bind("$sliderGoTo", Yr), t.bind("$sliderPause", Jr), t.bind("$sliderUnfocusHidden", Qr);
}, Ie = (t, e, n = e) => {
  const { scrollPaddingTop: i, scrollPaddingBottom: r } = window.getComputedStyle(t);
  return {
    top: Ce(i, e),
    bottom: Ce(r, n)
  };
}, Ce = (t, e) => t !== "auto" ? parseInt(t) : e, sa = 100, la = (t) => {
  t.addRootSelector(() => `[${t.prefixed("smartstick")}]`), t.directive("smartstick", (e, n, { cleanup: i }) => {
    let r = Ie(e, sa);
    const a = t.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + r.top}px`;
      }
    });
    let o = 0, s = window.scrollY;
    const l = () => {
      const g = window.scrollY, y = g - s;
      a.top = Math.min(o, Math.max(0, a.top + y)), s = g;
    }, c = () => {
      r = Ie(e, r.top, r.bottom), o = Math.max(0, e.clientHeight - window.innerHeight + r.top + r.bottom);
    }, d = new ResizeObserver(c);
    d.observe(e), window.addEventListener("resize", c);
    const u = window.matchMedia("(min-width: 1024px)"), p = (g) => window[g.matches ? "addEventListener" : "removeEventListener"]("scroll", l, { passive: !0 });
    u.addEventListener("change", p), p(u);
    const v = t.effect(() => e.style.top = a.topString);
    i(() => {
      t.release(v), d.disconnect(), u.removeEventListener("change", p), window.removeEventListener("resize", c), window.removeEventListener("scroll", l);
    });
  });
}, ie = (t, e, n) => {
  const i = /* @__PURE__ */ new WeakMap();
  return (r) => {
    r.addRootSelector(() => `[${r.prefixed(t)}]`);
    const a = (o) => {
      const s = r.findClosest(o, i.has.bind(i));
      if (!s) return console.error(`Could not find root for ${t} component`, o);
      if (s instanceof HTMLElement) return i.get(s);
    };
    r.magic(t, (o) => a(o)), r.directive(t, (o, s, l) => {
      if (!s.value) return i.set(o, e(o, s, l));
      const c = a(o);
      if (!c) return ua(t, o);
      (n?.[s.value] || ca(t))(c, o, s, l);
    });
  };
}, ca = (t) => (e, n, i) => {
  console.error(`Alpine ${t}: Invalid directive value`, n, i.original);
}, ua = (t, e) => console.error(`Could not find root for ${t} component`, e), Ot = /* @__PURE__ */ new WeakMap(), da = (t, e) => {
  const n = e.findClosest(t, Ot.has.bind(Ot));
  if (n instanceof HTMLElement) return Ot.get(n);
}, fa = (t, e, { Alpine: n, effect: i }) => {
  const r = n.reactive({
    active: null,
    id: 0,
    addAccordion(a) {
      const o = this.id++, s = n.reactive({ active: a });
      return i(() => {
        s.active ? this.active = o : this.active === o && (this.active = null);
      }), i(() => {
        this.active === o ? s.active = !0 : s.active = !1;
      }), s;
    }
  });
  return Ot.set(t, r), r;
}, ha = (t) => {
  t.addRootSelector(() => `[${t.prefixed("accordion-group")}]`), t.directive("accordion-group", fa);
}, pa = (t, { modifiers: [e = "closed"] }, { Alpine: n }) => da(t, n)?.addAccordion(e === "open") ?? n.reactive({ active: e === "open" }), va = {
  open: !0,
  close: !1,
  toggle: null
}, ma = (t, e, { modifiers: [n = "toggle"] }, { Alpine: i }) => {
  i.bind(e, {
    "x-on:click": () => {
      t.active = va[n] ?? !t.active;
    },
    ":aria-expanded": () => t.active
  });
}, ga = (t, e, n, { Alpine: i }) => {
  i.bind(e, { "x-show": () => t.active });
}, ba = {
  control: ma,
  container: ga
}, ya = ie("accordion", pa, ba), wa = (t) => {
  ha(t), ya(t);
}, Ne = new ResizeObserver((t) => {
  for (const e of t) {
    const n = e.target;
    n instanceof HTMLElement && xa(n);
  }
}), xa = async (t) => {
  await xt.nextTick(), t.scrollLeft = (t.scrollWidth - t.clientWidth) / 2, t.scrollTop = (t.scrollHeight - t.clientHeight) / 2;
}, Oe = Array.prototype.forEach, Sa = (t) => t.directive("dragscroll", (e, { modifiers: n }, { cleanup: i }) => {
  const r = n.includes("center");
  i(Ea(e)), e.classList.add("overscroll-contain", "cursor-grab"), r && (Oe.call(e.children, (a) => Ne.observe(a)), i(() => Oe.call(e.children, (a) => Ne.unobserve(a))));
}), pt = (t) => {
  t.preventDefault(), t.stopPropagation();
}, Le = [
  "pointerup",
  "mouseup",
  "touchend"
], Ea = (t) => {
  const e = (r) => {
    pt(r), t.scrollLeft -= r.movementX, t.scrollTop -= r.movementY;
  }, n = async (r) => {
    pt(r), document.removeEventListener("pointermove", e, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), t.classList.add("cursor-grab"), await xt.nextTick(), document.removeEventListener("click", pt, !0), Le.forEach((a) => document.removeEventListener(a, n, { capture: !0 }));
  }, i = (r) => {
    Ta(r) || r.button !== 2 && (pt(r), t.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", e, { capture: !0 }), Le.forEach((a) => document.addEventListener(a, n, { capture: !0 })), document.addEventListener("click", pt, { capture: !0 }));
  };
  return t.addEventListener("pointerdown", i), () => t.removeEventListener("pointerdown", i);
}, Ta = (t) => t instanceof TouchEvent || t instanceof PointerEvent && t.pointerType === "touch", ka = (t, e, { Alpine: n }) => {
  const i = n.reactive({
    root: t,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(t, { "x-id": () => ["x-panel"] }), i;
}, Ia = ie("panel", ka, {
  summary: (t, e, n, { Alpine: i }) => {
    i.bind(e, {
      ":aria-expanded": () => t.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (t, e, n, { Alpine: i }) => {
    i.bind(e, {
      "x-show": () => t.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Ca = ie("tabs", (t, e, { Alpine: n, evaluate: i }) => n.reactive({
  activeTab: 0,
  isSelected(r) {
    return this.tabs[this.activeTab] === r;
  },
  tabs: [],
  panels: [],
  $focus: i("$focus")
}), {
  list: (t, e, n, { Alpine: i }) => {
    const r = () => t.$focus.wrap().next(), a = () => t.$focus.wrap().previous();
    i.bind(e, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": a,
      "@keydown.arrow-right.stop.prevent": r,
      "@keydown.arrow-up.stop.prevent": a,
      "@keydown.arrow-down.stop.prevent": r
    });
  },
  tab: (t, e, n, { Alpine: i }) => {
    const r = t.tabs.push(e) - 1, a = () => t.activeTab = r;
    i.bind(e, {
      ":tabindex": () => +(r === t.activeTab) - 1,
      ":aria-selected": () => r === t.activeTab,
      "@click": a,
      "@keydown.space.stop.prevent": a,
      "@keydown.enter.stop.prevent": a
    });
  },
  panel: (t, e, n, { Alpine: i }) => {
    const r = t.panels.push(e) - 1;
    i.bind(e, {
      ":tab-index": () => r !== t.activeTab ? -1 : 0,
      ":aria-hidden": () => r !== t.activeTab,
      ":class"() {
        if (r === t.activeTab) return "panel-current";
        if (r > t.activeTab) return "panel-next";
        if (r < t.activeTab) return "panel-previous";
      }
    });
  }
}), yt;
(function(t) {
  t[t.None = 0] = "None", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Up = 4] = "Up", t[t.Down = 8] = "Down";
})(yt || (yt = {}));
var wt = /* @__PURE__ */ new WeakMap(), Na = wt.has.bind(wt), Oa = (t) => t.directive("swipe", (e, n, { cleanup: i }) => {
  wt.set(e, { dispatch: (r) => {
    const a = Object.entries(yt).filter(([, o]) => typeof o == "number" && o && (r & o) === o).map(([o]) => o.toLowerCase());
    e.dispatchEvent(new CustomEvent("swipe", { detail: a.join("-") })), e.dispatchEvent(new CustomEvent(`swipe${a.join("")}`, { detail: a.join("-") }));
  } }), e.addEventListener("touchstart", _e), i(() => e.removeEventListener("touchstart", _e));
}), _e = (t) => {
  const e = wt.get(t.currentTarget);
  if (!e) return;
  const { clientX: n, clientY: i } = t.touches[0];
  e.start ??= {
    x: n,
    y: i
  }, document.addEventListener("touchend", La, { once: !0 });
}, La = (t) => {
  const e = t.target;
  if (!e) return;
  const n = wt.get(cn(e, Na));
  if (!n?.start) return;
  const { clientX: i, clientY: r } = t.changedTouches[0], a = _a(n.start, {
    x: i,
    y: r
  });
  a !== yt.None && (n.dispatch(a), delete n.start);
}, cn = (t, e) => e(t) ? t : t.parentElement ? cn(t.parentElement, e) : null, _a = (t, e) => {
  const n = [e.x - t.x, e.y - t.y];
  if (n.every((o) => Math.abs(o) < 50)) return yt.None;
  const i = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [r, a] = n.map((o) => o / i);
  return Fe(r) | Fe(a) << 2;
}, Fe = (t) => t > 0.5 ? 2 : t < -0.5 ? 1 : 0, Fa = (t) => {
  t.magic("screen", () => (e) => {
    const n = typeof e == "number" ? e : Aa[e] ?? Number(e);
    return n ? $a(n, t).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(e)})`), !1);
  });
}, Aa = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, un = {}, $a = (t, e) => un[t] ?? Ra(t, e), Ra = (t, e) => {
  const n = window.matchMedia(`(min-width: ${t}px)`), i = e.reactive({ value: n.matches });
  return un[t] = i, n.addEventListener("change", (r) => {
    i.value = r.matches;
  }), i;
}, Da = (t) => t.plugin([Fa]), Pa = (t) => t.plugin([
  wa,
  Sa,
  Ia,
  Oa,
  Ca,
  Da
]), Ma = (t) => {
  t.magic("abortSignal", (e, { cleanup: n }) => {
    const i = new AbortController();
    return n(() => i.abort()), i.signal;
  });
}, ja = (t) => {
  t.magic("dataset", (e) => e.dataset), t.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : fn);
}, Ba = (t) => {
  t.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, Va = (t) => {
  t.directive("inert-trap", (e, { expression: n, modifiers: i }, { evaluateLater: r, effect: a }) => {
    const o = i.includes("retain"), s = i.includes("noscroll"), l = i.includes("return"), c = r(n), d = [];
    let u = null;
    a(() => {
      c((p) => {
        if (p) {
          u = document.activeElement;
          for (const v of qa(e, ...document.querySelectorAll("[role=alertdialog]"), o ? u?.closest("[data-retain-focus-from]") ?? u : null))
            v.setAttribute("inert", "inert"), d.push(v);
          s && (document.documentElement.style.setProperty("overflow", "hidden"), document.body.style.setProperty("overflow", "hidden"));
        } else {
          for (const v of d) v.removeAttribute("inert");
          d.length = 0, s && (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("overflow")), l && u && (u.focus(), u = null);
        }
      });
    });
  });
};
function qa(...t) {
  return t = t.filter((e) => e !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (e) => {
    if (!(e instanceof HTMLElement) || e.matches("[inert] > *") || t.includes(e)) return NodeFilter.FILTER_REJECT;
    for (const n of t) if (e.contains(n)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let t = this.nextNode();
  for (; t; )
    yield t, t = this.nextNode();
};
var Ha = (t) => {
  t.directive("highlight-scroll", (e, { expression: n }, { cleanup: i }) => {
    const r = n.trim();
    if (!r) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const a = e.firstChild;
    if (!a || !(a instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const o = (a.textContent?.trim().split("") ?? []).map((c) => {
      const d = document.createElement("span");
      return d.textContent = c, d.classList.add(r), d;
    });
    a.replaceWith(...o);
    let s = -1;
    const l = setInterval(() => {
      s == -1 ? o.forEach((c) => c.classList.remove(r)) : o[s]?.classList.remove(r), s += 1, s %= o.length, o[s]?.classList.add(r);
    }, 500);
    i(() => clearInterval(l));
  }), t.addInitSelector(() => t.prefixed("highlight-scroll"));
}, za = [
  Ma,
  Vi,
  Vr,
  qr,
  Hi,
  wr,
  Ur,
  Va,
  kr,
  Ba,
  Fr,
  jr({
    shopify: !0,
    autoSize: !0
  }),
  Ha,
  oa,
  la,
  Kr,
  Pa,
  ja
], Ua = (t) => t.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), Ka = (t) => t.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), Wa = [
  hn,
  Ua,
  Ka,
  pn
];
xt.plugin([
  ...za,
  ...Wa,
  ...si
]);
window.Alpine = xt;
var Ga = xt, Qa = Ga;
export {
  Qa as default
};
